<template>
  <div :class="{ 'frp-board-filtered': board.filter }">
    <section v-if="frsm" class="section">
      <section id="views" class="hero title-card">
        <div class="hero-body">
          <div class="container">
            <h1 class="title is-4 mb-0">
              Resumen del Resultado de Factores de riesgos psicosociales
            </h1>
          </div>
          <div class="frp-header-date">
            <span>Fecha de diagnóstico</span>
            <h4 class="has-text-dark">{{ header.date }}</h4>
          </div>
        </div>
      </section>

      <!-- Actions -->
      <div class="frp-header-actions">
        <a
          v-if="!this.$route.params.id && (tokenUser.admin || tokenUser.cliente)"
          href="javascript:void(0)"
          class="button is-small is-dark radius-6 frp-action-labeled"
          v-on:click="showCtx"
          v-tooltip="
            board.benchmark
              ? 'Clic para cerrar benchmark'
              : 'Clic para ver benchmark'
          "
        >
          <img
            src="@/assets/icons/ranking-linear.svg"
            alt="benchmark"
            class="btn-benchmark-icon"
          />
          <span>{{ board.benchmark ? "Ocultar Benchmark" : "Benchmark" }}</span>
        </a>
        <a
          v-if="!this.$route.params.id"
          href="javascript:void(0)"
          class="button is-small is-dark radius-6"
          v-on:click="downloadData()"
          v-tooltip="'Descargar Excel de todos los datos'"
        >
          <i class="material-icons">grid_on</i>
        </a>
        <a
          v-if="!this.$route.params.id"
          href="javascript:void(0)"
          class="button is-small is-dark radius-6"
          v-on:click="downloadReport()"
          v-tooltip="'Descargar PDF del informe general'"
        >
          <i class="material-icons">cloud_download</i>
        </a>
        <a
          href="javascript:void(0)"
          class="button is-small is-dark radius-6"
          v-on:click="copyLink()"
          v-tooltip="'Copiar link para compartir el tablero'"
        >
          <i class="material-icons">share</i>
        </a>
      </div>

      <!-- Active filter banner: fixed to the top of the content area -->
      <transition name="frp-slide-down">
        <div
          v-if="board.filter"
          class="frp-filter-banner"
          :style="{ left: isOculto ? '68px' : '250px' }"
        >
          <span class="frp-filter-banner-label">
            <i class="material-icons">filter_alt</i>
            <strong>Vista filtrada</strong>
          </span>

          <div class="frp-filter-banner-items">
            <!-- Board filters -->
            <span
              v-for="(v, k) in board.filter"
              :key="k + 'board'"
              class="frp-filter-chip"
            >
              <span class="frp-filter-chip-group">{{
                String(v.gr).replace("AGR-", "")
              }}</span>
              <span class="frp-filter-chip-sub">{{ v.subgr }}</span>
              <button
                v-if="!isPermanentFilter(v)"
                class="frp-filter-chip-delete"
                aria-label="Quitar filtro"
                v-on:click="deselectOne(v)"
              >
                ✕
              </button>
            </span>

            <!-- Comparison vs historic -->
            <span v-if="board.historic.filter" class="frp-filter-vs">VS</span>
            <span
              v-for="(v, k) in board.historic.filter"
              :key="k + 'historic'"
              class="frp-filter-chip frp-filter-chip--historic"
            >
              <span class="frp-filter-chip-group">{{
                String(v.gr).replace("AGR-", "")
              }}</span>
              <span class="frp-filter-chip-sub">{{ v.subgr }}</span>
            </span>
          </div>

          <button
            v-if="!board.demo && !this.$route.params.id"
            class="frp-filter-banner-clear"
            v-on:click="deselectFilter"
          >
            <i class="material-icons">delete_sweep</i> Limpiar filtros
          </button>
        </div>
      </transition>

      <!-- First Part Header of Quadrants -->
      <div
        class="columns frp-quadrants"
        :class="{ 'has-forma-intra': formaIntra.length }"
      >
        <div class="column" :class="formaIntra.length ? 'is-2' : 'is-3'">
          <KpiCard
            class="frp-encuestados-kpi"
            icon="account-group-outline"
            title="Encuestados"
            :value="header.surveyed"
            subtitle="Respondieron la encuesta"
            value-color="#522687"
          />
        </div>
        <div class="column is-6">
          <CriticalCasesCard
            :data="filteredData['dataAdmin']['RGO-12-CASOS CRÍTICOS']"
            :cambio="cambio"
          />
        </div>
        <div class="column" :class="formaIntra.length ? 'is-4' : 'is-3'">
          <div class="box frp-graph-card">
            <div class="frp-card-header">
              <b-icon icon="briefcase-outline" class="mr-2" />
              <h3 class="title is-6 mb-0">Forma</h3>
              <span
                v-if="formaIntra.length"
                class="frp-forma-period"
                :class="
                  formaPeriodicidad === 'Un año'
                    ? 'frp-forma-period--alta'
                    : 'frp-forma-period--baja'
                "
              >
                <b-icon icon="calendar-clock" size="is-small" />
                Periodicidad: {{ formaPeriodicidad }}
              </span>
              <span
                v-if="formaIntra.length"
                class="frp-forma-info"
                v-tooltip.bottom="{
                  content: formaInfoTooltip,
                  classes: ['critical-tooltip'],
                  html: true,
                }"
              >
                <i class="material-icons">info_outline</i>
              </span>
            </div>
            <hr class="frp-card-divider" />
            <div
              class="frp-forma-body"
              :class="{ 'has-intra': formaIntra.length }"
            >
              <div class="frp-graph-area">
                <y-graph :datagraph="formaDona" :cambio="cambio"></y-graph>
              </div>
              <table v-if="formaIntra.length" class="frp-forma-table">
                <thead>
                  <tr>
                    <th v-for="f in formaIntra" :key="f.SubGrupo + '-h'">
                      <span
                        class="frp-fi-swatch"
                        :style="{ background: formaPieColor(f.SubGrupo) }"
                      ></span>
                      <span class="frp-fi-forma">Forma {{ f.SubGrupo }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-for="f in formaIntra" :key="f.SubGrupo + '-v'">
                      <span
                        class="frp-fi-prom"
                        :style="{
                          background: rangoFp(f.nivel, 0).color,
                          borderColor: rangoFp(f.nivel, 0).border,
                        }"
                        >{{ f.promedio }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td v-for="f in formaIntra" :key="f.SubGrupo + '-n'">
                      <span class="frp-fi-nivel">{{ f.nivel }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Options Historical -->
      <div
        class="is-flex"
        style="justify-content: space-between !important; margin-bottom: 10px !important;"
      >
        <div class="is-flex" v-if="!this.$route.params.id">
          <div class="control">
            <div class="select is-small">
              <!-- class is-loading for animate of loading -->
              <select
                :disabled="!board.historic.years"
                v-model="selects.inputHistoric"
              >
                <option value="" disabled selected>{{
                  board.historic.years
                    ? "Selecciona un histórico"
                    : "No hay histórico"
                }}</option>
                <option
                  v-for="(v, k) in board.historic.years"
                  :key="k"
                  :value="v"
                  >Histórico - {{ v }}</option
                >
              </select>
            </div>
          </div>

          <menu-filters-historic
            v-if="board.historic.selectYear"
            ref="menuGroupsHistoric"
            :data="getGroupsHistoric()"
            @setFilterHistoric="setFilterHistoric"
            @deleteFilterHistoric="deleteFilterHistoric"
          />

          <span
            v-tooltip="'Eliminar selección'"
            v-if="board.historic.selectYear"
            v-on:click="deleteSelectionHistoric"
            class="icon is-left is-danger"
            style="color: #f38282; margin-left: 10px; cursor: pointer;"
          >
            <i class="material-icons">delete_forever</i>
          </span>
        </div>
        <div v-if="this.$route.params.id">
          <div class="control" v-if="board.historic.selectYear !== ''">
            <div class="tags has-addons">
              <span class="tag is-grey-light">Histórico</span>
              <span class="tag is-blue">{{ board.historic.selectYear }}</span>
            </div>
          </div>
        </div>
        <div style="display: flex; gap: 8px;">
          <div
            v-if="!this.$route.params.id"
            v-tooltip="
              this.board.demo
                ? 'Clic para cerrar los demográficos'
                : 'Clic para ver los demográficos'
            "
            v-on:click="showDemo"
          >
            <a class="button is-small">{{
              board.demo ? "Cerrar demográficos" : "Demográficos"
            }}</a>
          </div>
        </div>
      </div>

      <!-- Demographic -->
      <transition name="fade">
        <Demographic
          v-if="board.demo"
          :frsm="filteredData"
          @sortData="sortData"
        ></Demographic>
      </transition>

      <!-- Benchmark -->
      <transition name="fade">
        <Benchmark
          v-if="board.benchmark"
          :frsm="frsm"
          :groups="groups"
          :efectos="efectos"
          :rangoIntervencion="rangoIntervencion"
          :showSubGroups="showSubGroups"
          :createBodyTooltipInter="createBodyTooltipInter"
          :getDataInter="getDataInter"
          :validateDataGraph="validateDataGraph"
          :calculatePorcentage="calculatePorcentage"
          :rangoFp="rangoFp"
        ></Benchmark>
      </transition>

      <div v-if="!board.demo && !board.benchmark">
        <!-- Second Part Header of Quadrants (sticky legend) -->

        <div ref="legendSentinel" class="frp-legend-sentinel"></div>
        <div
          class="frp-legend-wrap"
          :style="legendStuck ? { height: legendHeight + 'px' } : null"
        >
          <div
            ref="legendBar"
            v-show="!legendSuppressed"
            class="box frp-section-card frp-legend-bar"
            :class="{ 'is-stuck': legendStuck, 'is-filtered': !!board.filter }"
            :style="legendStuck ? { left: isOculto ? '68px' : '250px' } : null"
          >
            <div class="columns has-text-centered">
              <div class="column is-one-third">
                <span class="heading has-text-weight-bold"
                  >Prioridad de intervención</span
                >
              <div class="column">
                <table class="is-flex is-fullwidth" id="table-1">
                  <tr
                    class="bg-alta"
                    v-tooltip.bottom-start="{
                      content: `<span class='has-text-centered' style='width: 100%'>Si Riesgo Alto y Riesgo muy alto es mayor o igual a 30%</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Alta
                  </tr>
                  <tr
                    class="bg-media"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'>Si Riesgo Alto y Riesgo muy alto es menor a 30%, pero Riesgo alto, muy alto y medio es mayor o igual a 40%</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Media
                  </tr>
                  <tr
                    class="bg-destacado"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'>Si sin riesgo o riesgo bajo es mayor o igual a 60%</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Destacado
                  </tr>
                </table>
              </div>
            </div>
            <div class="column">
              <span class="heading has-text-weight-bold"
                >Niveles de riesgo</span
              >
              <div class="column">
                <table class="is-flex is-fullwidth" id="table-2">
                  <tr
                    class="bg-muyAlto"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Muy alto</strong><br><br>Nivel de riesgo con amplia posibilidad de asociarse a respuestas muy altas de estrés. Por consiguiente, las dimensiones y dominios que se encuentren bajo esta categoría requieren intervención inmediata en el marco de un sistema de vigilancia epidemiológica.</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Muy alto
                  </tr>
                  <tr
                    class="bg-alto"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Alto</strong><br><br>Nivel de riesgo que tiene una importante posibilidad de asociación con respuestas de estrés alto y por tanto, las dimensiones y dominios que se encuentren bajo esta categoría requieren intervención en el marco de un sistema de vigilancia epidemiológica.</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Alto
                  </tr>
                  <tr
                    class="bg-media"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Medio</strong><br><br>Nivel de riesgo en el que se esperaría una respuesta de estrés moderada. Las dimensiones y dominios que se encuentren bajo esta categoría ameritan observación y acciones sistemáticas de intervención para prevenir efectos perjudiciales en la salud.</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Medio
                  </tr>
                  <tr
                    class="bg-bajo"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Bajo</strong><br><br>No se espera que los factores psicosociales que obtengan puntuaciones en este nivel estén relacionados con síntomas o respuestas de estrés significativas. Las dimensiones y dominios que se encuentren bajo esta categoría serán objeto de acciones o programas de intervención, a fin de mantenerlos en los niveles de riesgo más bajos posibles.<br><strong>Este rango no aplica para las condiciones individuales.</strong></span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Bajo
                  </tr>
                  <tr
                    class="bg-noRiesgo"
                    v-tooltip.bottom="{
                      content: `<span class='has-text-centered' style='width: 100%'><strong class='has-text-white'>Sin riesgo o riesgo despreciable</strong><br><br>Ausencia de riesgo o riesgo tan bajo que no amerita desarrollar actividades de intervención. Las dimensiones y dominios que se encuentren bajo esta categoría serán objeto de acciones o programas de promoción.</span>`,
                      classes: 'contentTooltipRangeInter',
                    }"
                  >
                    Sin riesgo...
                  </tr>
                </table>
              </div>
            </div>
          </div>
          </div>
        </div>

        <!-- Results scope title (whole organization or the applied filter) -->
        <div class="is-flex is-justify-center">
          <hr class="has-text-dark" style="width: 30%" />
          <h1
            class="title is-size-4"
            style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
          >
            {{ resultsScopeTitle }}
          </h1>
          <hr class="has-text-dark" style="width: 30%" />
        </div>

        <!-- Third Part Quadrants -->

        <div class="box frp-section-card">
          <!-- Principales -->
          <div v-for="(v, k) in groups" :key="k + 'graphsP'">
            <!-- Data Normal -->
            <div class="columns has-text-centered">
              <!-- Column Title -->
              <div class="column is-one-third">
                <div>
                  <div
                    class="heading is-size-6 border"
                    :class="
                      rangoIntervencion(filteredData['dataAdmin'][v.first])
                    "
                    style="padding-top: 5px; margin-top: 15px;"
                  >
                    <div class="columns">
                      <!-- Icon -->
                      <div class="column is-2">
                        <i
                          class="material-icons has-text-white icon-dash"
                          v-tooltip.top="'Ver más'"
                          v-on:click="showSubGroups(k)"
                          style="cursor: pointer;"
                        >
                          {{
                            v.active
                              ? "remove_circle_outline"
                              : "add_circle_outline"
                          }}
                        </i>
                      </div>
                      <!-- Text -->
                      <div class="column titleC">
                        {{
                          interpretations[v.first]
                            ? interpretations[v.first].title
                            : "Error en los datos."
                        }}
                      </div>
                      <div
                        v-tooltip.top="{
                          content: createBodyTooltipInter(v),
                          classes: 'contentTooltipInter',
                        }"
                        class="column is-2"
                        v-on:click="
                          getDataInter(
                            filteredData['dataAdmin'][v.first],
                            v.title,
                          )
                        "
                      >
                        <i
                          class="material-icons has-text-white icon-dash"
                          style="cursor: pointer;"
                        >
                          info
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Columns Graph -->
              <div class="column">
                <div
                  style="padding-top: 0.6% !important; margin: 0px !important; width: 100%"
                >
                  <div
                    class="has-text-centered content-nodata-graph"
                    :class="
                      rangoIntervencion(filteredData['dataAdmin'][v.first])
                    "
                    v-if="
                      !validateDataGraph(filteredData['dataAdmin'][v.first])
                    "
                  >
                    <span class="is-flex"
                      ><i class="material-icons">insert_chart</i>&nbsp;No hay
                      suficientes datos</span
                    >
                  </div>

                  <y-graph
                    v-if="validateDataGraph(filteredData['dataAdmin'][v.first])"
                    :datagraph="
                      createDataGraphHorizontalBar(
                        filteredData['dataAdmin'][v.first],
                        v.title,
                      )
                    "
                    :cambio="cambio"
                    style="height: 65px !important;"
                  ></y-graph>
                </div>
              </div>
            </div>
            <!-- Data Historic -->
            <div
              class="columns has-text-centered content-historic"
              v-if="
                board.historic.selectYear !== '' &&
                  filteredDataHistoric[v.first]
              "
            >
              <!-- Column Title -->
              <div class="column is-one-third">
                <div>
                  <div
                    class="heading is-size-6 border"
                    :class="rangoIntervencion(filteredDataHistoric[v.first])"
                    style="padding-top: 5px; margin-top: 15px;"
                  >
                    <div class="columns">
                      <div class="column is-2"></div>
                      <!-- Text -->
                      <div class="column titleC">
                        {{
                          interpretations[v.first]
                            ? board.historic.selectYear +
                              " - " +
                              interpretations[v.first].title
                            : "Error en los datos."
                        }}
                      </div>
                      <div
                        v-tooltip.top="{
                          content: createBodyTooltipInter(v),
                          classes: 'contentTooltipInter',
                        }"
                        class="column is-2"
                        v-on:click="
                          getDataInter(filteredDataHistoric[v.first], v.title)
                        "
                      >
                        <i
                          class="material-icons has-text-white icon-dash"
                          style="cursor: pointer;"
                        >
                          info
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Columns Graph -->
              <div class="column">
                <div
                  style="padding-top: 0.6% !important; margin: 0px !important; width: 100%"
                >
                  <div
                    class="has-text-centered content-nodata-graph"
                    :class="rangoIntervencion(filteredDataHistoric[v.first])"
                    v-if="!validateDataGraph(filteredDataHistoric[v.first])"
                  >
                    <span class="is-flex"
                      ><i class="material-icons">insert_chart</i>&nbsp;No hay
                      suficientes datos</span
                    >
                  </div>

                  <y-graph
                    v-if="validateDataGraph(filteredDataHistoric[v.first])"
                    :datagraph="
                      createDataGraphHorizontalBar(
                        filteredDataHistoric[v.first],
                        v.title,
                      )
                    "
                    :cambio="cambio"
                    style="height: 65px !important;"
                  ></y-graph>
                </div>
              </div>
            </div>

            <article v-if="v.sub && !v.sub2 && v.active" class="message">
              <div class="message-body">
                <div v-for="(vS, kS) in v.sub" :key="kS + 'sub1'">
                  <!-- Data Normal -->
                  <div class="columns has-text-centered">
                    <!-- Column Title -->
                    <div class="column is-one-third">
                      <div>
                        <div
                          class="heading is-size-6 border"
                          :class="
                            rangoIntervencion(
                              filteredData['dataAdmin'][vS.first],
                            )
                          "
                          style="padding-top: 5px; margin-top: 15px;"
                        >
                          <div class="columns">
                            <div class="column is-2"></div>
                            <!-- Text -->
                            <div class="column titleC">
                              {{
                                interpretations[vS.first]
                                  ? interpretations[vS.first].title
                                  : "Error en los datos."
                              }}
                            </div>
                            <div
                              v-tooltip.top="{
                                content: createBodyTooltipInter(vS),
                                classes: 'contentTooltipInter',
                              }"
                              class="column is-2"
                              v-on:click="
                                getDataInter(
                                  filteredData['dataAdmin'][vS.first],
                                  vS.title,
                                )
                              "
                            >
                              <i
                                class="material-icons has-text-white icon-dash"
                                style="cursor: pointer;"
                              >
                                info
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Columns Graph -->
                    <div class="column">
                      <div
                        style="padding-top: 0.6% !important; margin: 0px !important;"
                      >
                        <div
                          class="has-text-centered content-nodata-graph"
                          :class="
                            rangoIntervencion(
                              filteredData['dataAdmin'][vS.first],
                            )
                          "
                          v-if="
                            !validateDataGraph(
                              filteredData['dataAdmin'][vS.first],
                            )
                          "
                        >
                          <span class="is-flex"
                            ><i class="material-icons">insert_chart</i>&nbsp;No
                            hay suficientes datos</span
                          >
                        </div>

                        <y-graph
                          v-if="
                            validateDataGraph(
                              filteredData['dataAdmin'][vS.first],
                            )
                          "
                          :datagraph="
                            createDataGraphHorizontalBar(
                              filteredData['dataAdmin'][vS.first],
                              vS.title,
                            )
                          "
                          :cambio="cambio"
                          style="height: 65px !important;"
                        ></y-graph>
                      </div>
                    </div>
                  </div>
                  <!-- Data Historic -->
                  <div
                    class="columns has-text-centered content-historic"
                    v-if="
                      board.historic.selectYear !== '' &&
                        filteredDataHistoric[vS.first]
                    "
                  >
                    <!-- Column Title -->
                    <div class="column is-one-third">
                      <div>
                        <div
                          class="heading is-size-6 border"
                          :class="
                            rangoIntervencion(filteredDataHistoric[vS.first])
                          "
                          style="padding-top: 5px; margin-top: 15px;"
                        >
                          <div class="columns">
                            <div class="column is-2"></div>
                            <!-- Text -->
                            <div class="column titleC">
                              {{
                                interpretations[vS.first]
                                  ? interpretations[vS.first].title
                                  : "Error en los datos."
                              }}
                            </div>
                            <div
                              v-tooltip.top="{
                                content: createBodyTooltipInter(vS),
                                classes: 'contentTooltipInter',
                              }"
                              class="column is-2"
                              v-on:click="
                                getDataInter(
                                  filteredDataHistoric[vS.first],
                                  vS.title,
                                )
                              "
                            >
                              <i
                                class="material-icons has-text-white icon-dash"
                                style="cursor: pointer;"
                              >
                                info
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Columns Graph -->
                    <div class="column">
                      <div
                        style="padding-top: 0.6% !important; margin: 0px !important;"
                      >
                        <div
                          class="has-text-centered content-nodata-graph"
                          :class="
                            rangoIntervencion(filteredDataHistoric[vS.first])
                          "
                          v-if="
                            !validateDataGraph(filteredDataHistoric[vS.first])
                          "
                        >
                          <span class="is-flex"
                            ><i class="material-icons">insert_chart</i>&nbsp;No
                            hay suficientes datos</span
                          >
                        </div>

                        <y-graph
                          v-if="
                            validateDataGraph(filteredDataHistoric[vS.first])
                          "
                          :datagraph="
                            createDataGraphHorizontalBar(
                              filteredDataHistoric[vS.first],
                              vS.title,
                            )
                          "
                          :cambio="cambio"
                          style="height: 65px !important;"
                        ></y-graph>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>

            <article v-if="v.sub2 && v.active" class="message">
              <div class="message-body">
                <div v-for="(vS, kS) in v.sub2" :key="kS + 'sub2'">
                  <!-- Data Normal -->
                  <div class="columns has-text-centered">
                    <!-- Column Title -->
                    <div class="column is-one-third">
                      <div>
                        <div
                          class="heading is-size-6 border"
                          :class="
                            rangoIntervencion(
                              filteredData['dataAdmin'][vS.first],
                            )
                          "
                          style="padding-top: 5px; margin-top: 15px;"
                        >
                          <div class="columns">
                            <!-- Icon -->
                            <div class="column is-2">
                              <i
                                v-tooltip="'Ver más'"
                                class="material-icons has-text-white icon-dash"
                                v-on:click="showSubGroups(k, kS)"
                                style="cursor: pointer;"
                              >
                                {{
                                  vS.active
                                    ? "remove_circle_outline"
                                    : "add_circle_outline"
                                }}
                              </i>
                            </div>
                            <!-- Text -->
                            <div class="column titleC">
                              {{
                                interpretations[vS.first]
                                  ? interpretations[vS.first].title
                                  : "Error en los datos."
                              }}
                            </div>
                            <div
                              v-tooltip.top="{
                                content: createBodyTooltipInter(vS),
                                classes: 'contentTooltipInter',
                              }"
                              class="column is-2"
                              v-on:click="
                                getDataInter(
                                  filteredData['dataAdmin'][vS.first],
                                  vS.title,
                                )
                              "
                            >
                              <i
                                class="material-icons has-text-white icon-dash"
                                style="cursor: pointer;"
                              >
                                info
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Columns Graph -->
                    <div class="column">
                      <div
                        style="padding-top: 0.6% !important; margin: 0px !important;"
                      >
                        <div
                          class="has-text-centered content-nodata-graph"
                          :class="
                            rangoIntervencion(
                              filteredData['dataAdmin'][vS.first],
                            )
                          "
                          v-if="
                            !validateDataGraph(
                              filteredData['dataAdmin'][vS.first],
                            )
                          "
                        >
                          <span class="is-flex"
                            ><i class="material-icons">insert_chart</i>&nbsp;No
                            hay suficientes datos</span
                          >
                        </div>
                        <y-graph
                          v-if="
                            validateDataGraph(
                              filteredData['dataAdmin'][vS.first],
                            )
                          "
                          :datagraph="
                            createDataGraphHorizontalBar(
                              filteredData['dataAdmin'][vS.first],
                              vS.title,
                            )
                          "
                          :cambio="cambio"
                          style="height: 65px !important;"
                        ></y-graph>
                      </div>
                    </div>
                  </div>
                  <!-- Data Historic -->
                  <div
                    class="columns has-text-centered content-historic"
                    v-if="
                      board.historic.selectYear !== '' &&
                        filteredDataHistoric[vS.first]
                    "
                  >
                    <!-- Column Title -->
                    <div class="column is-one-third">
                      <div>
                        <div
                          class="heading is-size-6 border"
                          :class="
                            rangoIntervencion(filteredDataHistoric[vS.first])
                          "
                          style="padding-top: 5px; margin-top: 15px;"
                        >
                          <div class="columns">
                            <div class="column is-2"></div>
                            <!-- Text -->
                            <div class="column titleC">
                              {{
                                interpretations[vS.first]
                                  ? interpretations[vS.first].title
                                  : "Error en los datos."
                              }}
                            </div>
                            <div
                              v-tooltip.top="{
                                content: createBodyTooltipInter(vS),
                                classes: 'contentTooltipInter',
                              }"
                              class="column is-2"
                              v-on:click="
                                getDataInter(
                                  filteredDataHistoric[vS.first],
                                  vS.title,
                                )
                              "
                            >
                              <i
                                class="material-icons has-text-white icon-dash"
                                style="cursor: pointer;"
                              >
                                info
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Columns Graph -->
                    <div class="column">
                      <div
                        style="padding-top: 0.6% !important; margin: 0px !important;"
                      >
                        <div
                          class="has-text-centered content-nodata-graph"
                          :class="
                            rangoIntervencion(filteredDataHistoric[vS.first])
                          "
                          v-if="
                            !validateDataGraph(filteredDataHistoric[vS.first])
                          "
                        >
                          <span class="is-flex"
                            ><i class="material-icons">insert_chart</i>&nbsp;No
                            hay suficientes datos</span
                          >
                        </div>

                        <y-graph
                          v-if="
                            validateDataGraph(filteredDataHistoric[vS.first])
                          "
                          :datagraph="
                            createDataGraphHorizontalBar(
                              filteredDataHistoric[vS.first],
                              vS.title,
                            )
                          "
                          :cambio="cambio"
                          style="height: 65px !important;"
                        ></y-graph>
                      </div>
                    </div>
                  </div>

                  <article
                    v-if="!v.sub && v.sub2 && vS.sub && vS.active"
                    class="message"
                  >
                    <div class="message-body">
                      <div v-for="(vT, kT) in vS.sub" :key="kT + 'sub3'">
                        <!-- Data Normal -->
                        <div class="columns has-text-centered">
                          <!-- Column Title -->
                          <div class="column is-one-third">
                            <div>
                              <div
                                class="heading is-size-6 border"
                                :class="
                                  rangoIntervencion(
                                    filteredData['dataAdmin'][vT.first],
                                  )
                                "
                                style="padding-top: 5px; margin-top: 15px;"
                              >
                                <div class="columns">
                                  <div class="column is-2"></div>
                                  <!-- Text -->
                                  <div class="column titleC">
                                    {{ interpretations[vT.first].title }}
                                  </div>
                                  <div
                                    v-tooltip.top="{
                                      content: createBodyTooltipInter(vT),
                                      classes: 'contentTooltipInter',
                                    }"
                                    class="column is-2"
                                  >
                                    <i
                                      class="material-icons has-text-white icon-dash"
                                      style="cursor: pointer;"
                                      v-on:click="
                                        getDataInter(
                                          filteredData['dataAdmin'][vT.first],
                                          vT.title,
                                        )
                                      "
                                    >
                                      info
                                    </i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Columns Graph -->
                          <div class="column">
                            <div
                              style="padding-top: 0.6% !important; margin: 0px !important;"
                            >
                              <div
                                class="has-text-centered content-nodata-graph"
                                :class="
                                  rangoIntervencion(
                                    filteredData['dataAdmin'][vT.first],
                                  )
                                "
                                v-if="
                                  !validateDataGraph(
                                    filteredData['dataAdmin'][vT.first],
                                  )
                                "
                              >
                                <span class="is-flex"
                                  ><i class="material-icons">insert_chart</i
                                  >&nbsp;No hay suficientes datos</span
                                >
                              </div>
                              <y-graph
                                v-if="
                                  validateDataGraph(
                                    filteredData['dataAdmin'][vT.first],
                                  )
                                "
                                :datagraph="
                                  createDataGraphHorizontalBar(
                                    filteredData['dataAdmin'][vT.first],
                                    vT.title,
                                  )
                                "
                                :cambio="cambio"
                                style="height: 65px !important;"
                              ></y-graph>
                            </div>
                          </div>
                        </div>
                        <!-- Data Historic -->
                        <div
                          class="columns has-text-centered content-historic"
                          v-if="
                            board.historic.selectYear !== '' &&
                              filteredDataHistoric[vT.first]
                          "
                        >
                          <!-- Column Title -->
                          <div class="column is-one-third">
                            <div>
                              <div
                                class="heading is-size-6 border"
                                :class="
                                  rangoIntervencion(
                                    filteredDataHistoric[vT.first],
                                  )
                                "
                                style="padding-top: 5px; margin-top: 15px;"
                              >
                                <div class="columns">
                                  <div class="column is-2"></div>
                                  <!-- Text -->
                                  <div class="column titleC">
                                    {{ interpretations[vT.first].title }}
                                  </div>
                                  <div
                                    v-tooltip.top="{
                                      content: createBodyTooltipInter(vT),
                                      classes: 'contentTooltipInter',
                                    }"
                                    class="column is-2"
                                  >
                                    <i
                                      class="material-icons has-text-white icon-dash"
                                      style="cursor: pointer;"
                                      v-on:click="
                                        getDataInter(
                                          filteredDataHistoric[vT.first],
                                          vT.title,
                                        )
                                      "
                                    >
                                      info
                                    </i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Columns Graph -->
                          <div class="column">
                            <div
                              style="padding-top: 0.6% !important; margin: 0px !important;"
                            >
                              <div
                                class="has-text-centered content-nodata-graph"
                                :class="
                                  rangoIntervencion(
                                    filteredDataHistoric[vT.first],
                                  )
                                "
                                v-if="
                                  !validateDataGraph(
                                    filteredDataHistoric[vT.first],
                                  )
                                "
                              >
                                <span class="is-flex"
                                  ><i class="material-icons">insert_chart</i
                                  >&nbsp;No hay suficientes datos</span
                                >
                              </div>

                              <y-graph
                                v-if="
                                  validateDataGraph(
                                    filteredDataHistoric[vT.first],
                                  )
                                "
                                :datagraph="
                                  createDataGraphHorizontalBar(
                                    filteredDataHistoric[vT.first],
                                    vS.title,
                                  )
                                "
                                :cambio="cambio"
                                style="height: 65px !important;"
                              ></y-graph>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </article>
          </div>
        </div>

        <div
          class="is-flex is-align-items-center frp-efectos-header"
          style="justify-content: space-between;"
        >
          <!-- Title Efectos -->
          <h1 class="title is-size-4 is-flex is-align-items-center" style="margin: 0;">
            Efectos
            <div
              v-tooltip.top="{
                content: createBodyTooltipInter({ first: 'EFECTOS' }),
                classes: 'contentTooltipInter',
              }"
              style="padding-left: 10px;padding-top: 2px;"
            >
              <i class="material-icons has-text-black-bis">
                info_outline
              </i>
            </div>
          </h1>
          <div class="frp-efectos-modo">
            <span
              class="frp-efectos-modo__opt"
              :class="{
                'frp-efectos-modo__opt--active':
                  board.efectosModo === 'niveles',
              }"
              v-on:click="board.efectosModo = 'niveles'"
              >Niveles de riesgo</span
            >
            <span
              class="frp-efectos-modo__opt"
              :class="{
                'frp-efectos-modo__opt--active':
                  board.efectosModo === 'variables',
              }"
              v-on:click="board.efectosModo = 'variables'"
              >Variables prioritarias</span
            >
          </div>
        </div>

        <div class="box frp-section-card" ref="efectosBox">
          <!-- Efectos -->
          <div v-if="board.efectosModo === 'niveles'">
          <div v-for="(v, k) in efectos" :key="k + 'graphsE'">
            <div v-if="v.first === 'RGO-09-Engagement'">
              <!-- Part Header of Quadrants - Engagement -->
              <div style="margin-right: 10px; margin-left: 10px;">
                <hr />
              </div>
              <div class="columns has-text-centered">
                <div class="column is-one-third">
                  <span class="heading has-text-weight-bold"
                    >Prioridad de intervención</span
                  >
                  <div class="column">
                    <table class="is-flex is-fullwidth" id="table-1">
                      <tr
                        class="bg-alta"
                        v-tooltip.bottom-start="{
                          content: `<span class='has-text-centered' style='width: 100%'>Si Muy bajo y bajo es mayor o igual a 30%</span>`,
                          classes: 'contentTooltipRangeInter',
                        }"
                      >
                        Alta
                      </tr>
                      <tr
                        class="bg-media"
                        v-tooltip.bottom="{
                          content: `<span class='has-text-centered' style='width: 100%'>Si Muy bajo y bajo es menor a 30%, pero Muy bajo, bajo y medio es mayor o igual a 40%</span>`,
                          classes: 'contentTooltipRangeInter',
                        }"
                      >
                        Media
                      </tr>
                      <tr
                        class="bg-destacado"
                        v-tooltip.bottom="{
                          content: `<span class='has-text-centered' style='width: 100%'>Si Muy alto y alto a 60%</span>`,
                          classes: 'contentTooltipRangeInter',
                        }"
                      >
                        Destacado
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="column">
                  <span class="heading has-text-weight-bold"
                    >Niveles de efecto</span
                  >
                  <div class="column">
                    <table class="is-flex is-fullwidth" id="table-2">
                      <tr class="bg-muyAltoEng">
                        Muy alto
                      </tr>
                      <tr class="bg-altoEng">
                        Alto
                      </tr>
                      <tr class="bg-media">
                        Medio
                      </tr>
                      <tr class="bg-bajoEng">
                        Bajo
                      </tr>
                      <tr class="bg-noRiesgoEng">
                        Muy bajo
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- Data Normal -->
            <div class="columns has-text-centered">
              <!-- Column Title -->
              <div class="column is-one-third">
                <div>
                  <div
                    class="heading is-size-6 border"
                    :class="
                      rangoIntervencion(
                        filteredData['dataAdmin'][v.first],
                        v.first === 'RGO-09-Engagement' ? 1 : 0,
                      )
                    "
                    style="padding-top: 5px; margin-top: 15px;"
                  >
                    <div class="columns">
                      <!-- Icon -->
                      <div class="column is-2">
                        <i
                          class="material-icons has-text-white icon-dash"
                          v-tooltip.top="'Ver más'"
                          v-on:click="showSubGroups(k)"
                          v-if="v.sub && v.sub.length"
                          style="cursor: pointer;"
                        >
                          {{
                            v.active
                              ? "remove_circle_outline"
                              : "add_circle_outline"
                          }}
                        </i>
                      </div>
                      <!-- Text -->
                      <div class="column titleC">
                        {{ interpretations[v.first].title }}
                      </div>
                      <div
                        v-tooltip.top="{
                          content: createBodyTooltipInter(v),
                          classes: 'contentTooltipInter',
                        }"
                        class="column is-2"
                        v-on:click="
                          getDataInter(
                            filteredData['dataAdmin'][v.first],
                            v.title,
                          )
                        "
                      >
                        <i
                          class="material-icons has-text-white icon-dash"
                          style="cursor: pointer;"
                        >
                          info
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Columns Graph -->
              <div class="column">
                <div
                  style="padding-top: 0.6% !important; margin: 0px !important; width: 100%"
                >
                  <div
                    class="has-text-centered content-nodata-graph"
                    :class="
                      rangoIntervencion(
                        filteredData['dataAdmin'][v.first],
                        v.first === 'RGO-09-Engagement' ? 1 : 0,
                      )
                    "
                    v-if="
                      !validateDataGraph(filteredData['dataAdmin'][v.first])
                    "
                  >
                    <span class="is-flex"
                      ><i class="material-icons">insert_chart</i>&nbsp;No hay
                      suficientes datos</span
                    >
                  </div>
                  <y-graph
                    v-if="validateDataGraph(filteredData['dataAdmin'][v.first])"
                    :datagraph="
                      createDataGraphHorizontalBar(
                        filteredData['dataAdmin'][v.first],
                        v.title,
                      )
                    "
                    :cambio="cambio"
                    style="height: 65px !important;"
                  ></y-graph>
                </div>
              </div>
            </div>
            <!-- Data Historic -->
            <div
              class="columns has-text-centered content-historic"
              v-if="
                board.historic.selectYear !== '' &&
                  filteredDataHistoric[v.first]
              "
            >
              <!-- Column Title -->
              <div class="column is-one-third">
                <div>
                  <div
                    class="heading is-size-6 border"
                    :class="
                      rangoIntervencion(
                        filteredDataHistoric[v.first],
                        v.first === 'RGO-09-Engagement' ? 1 : 0,
                      )
                    "
                    style="padding-top: 5px; margin-top: 15px;"
                  >
                    <div class="columns">
                      <!-- Icon -->
                      <div class="column is-2">
                        <i
                          class="material-icons has-text-white icon-dash"
                          v-tooltip.top="'Ver más'"
                          v-on:click="showSubGroups(k)"
                          v-if="v.sub && v.sub.length"
                          style="cursor: pointer;"
                        >
                          {{
                            v.active
                              ? "remove_circle_outline"
                              : "add_circle_outline"
                          }}
                        </i>
                      </div>
                      <!-- Text -->
                      <div class="column titleC">
                        {{ board.historic.selectYear }} -
                        {{ interpretations[v.first].title }}
                      </div>
                      <div
                        v-tooltip.top="{
                          content: createBodyTooltipInter(v),
                          classes: 'contentTooltipInter',
                        }"
                        class="column is-2"
                        v-on:click="
                          getDataInter(filteredDataHistoric[v.first], v.title)
                        "
                      >
                        <i
                          class="material-icons has-text-white icon-dash"
                          style="cursor: pointer;"
                        >
                          info
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Columns Graph -->
              <div class="column">
                <div
                  style="padding-top: 0.6% !important; margin: 0px !important; width: 100%"
                >
                  <div
                    class="has-text-centered content-nodata-graph"
                    :class="
                      rangoIntervencion(
                        filteredDataHistoric[v.first],
                        v.first === 'RGO-09-Engagement' ? 1 : 0,
                      )
                    "
                    v-if="!validateDataGraph(filteredDataHistoric[v.first])"
                  >
                    <span class="is-flex"
                      ><i class="material-icons">insert_chart</i>&nbsp;No hay
                      suficientes datos</span
                    >
                  </div>
                  <y-graph
                    v-if="validateDataGraph(filteredDataHistoric[v.first])"
                    :datagraph="
                      createDataGraphHorizontalBar(
                        filteredDataHistoric[v.first],
                        v.title,
                      )
                    "
                    :cambio="cambio"
                    style="height: 65px !important;"
                  ></y-graph>
                </div>
              </div>
            </div>

            <article v-if="v.sub && v.sub.length && v.active" class="message">
              <div class="message-body">
                <div v-for="(vS, kS) in v.sub" :key="kS + 'sub4'">
                  <!-- Data Normal -->
                  <div class="columns has-text-centered">
                    <!-- Column Title -->
                    <div class="column is-one-third">
                      <div>
                        <div
                          class="heading is-size-6 border"
                          :class="
                            rangoIntervencion(
                              filteredData['dataAdmin'][vS.first],
                            )
                          "
                          style="padding-top: 5px; margin-top: 15px;"
                        >
                          <div class="columns">
                            <div class="is-2"></div>
                            <!-- Text -->
                            <div class="column titleC">
                              {{ interpretations[vS.first].title }}
                            </div>
                            <div
                              v-tooltip.top="{
                                content: createBodyTooltipInter(vS),
                                classes: 'contentTooltipInter',
                              }"
                              class="column is-2"
                              v-on:click="
                                getDataInter(
                                  filteredData['dataAdmin'][vS.first],
                                  vS.title,
                                )
                              "
                            >
                              <i
                                class="material-icons has-text-white icon-dash"
                                style="cursor: pointer;"
                              >
                                info
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Columns Graph -->
                    <div class="column">
                      <div
                        style="padding-top: 0.6% !important; margin: 0px !important;"
                      >
                        <y-graph
                          :datagraph="
                            createDataGraphHorizontalBar(
                              filteredData['dataAdmin'][vS.first],
                              vS.title,
                            )
                          "
                          :cambio="cambio"
                          style="height: 65px !important;"
                        ></y-graph>
                      </div>
                    </div>
                  </div>
                  <!-- Data Historic -->
                  <div
                    class="columns has-text-centered content-historic"
                    v-if="
                      board.historic.selectYear !== '' &&
                        filteredDataHistoric[vS.first]
                    "
                  >
                    <!-- Column Title -->
                    <div class="column is-one-third">
                      <div>
                        <div
                          class="heading is-size-6 border"
                          :class="
                            rangoIntervencion(filteredDataHistoric[vS.first])
                          "
                          style="padding-top: 5px; margin-top: 15px;"
                        >
                          <div class="columns">
                            <div class="is-2"></div>
                            <!-- Text -->
                            <div class="column titleC">
                              {{ board.historic.selectYear }} -
                              {{ interpretations[vS.first].title }}
                            </div>
                            <div
                              v-tooltip.top="{
                                content: createBodyTooltipInter(vS),
                                classes: 'contentTooltipInter',
                              }"
                              class="column is-2"
                              v-on:click="
                                getDataInter(
                                  filteredDataHistoric[vS.first],
                                  vS.title,
                                )
                              "
                            >
                              <i
                                class="material-icons has-text-white icon-dash"
                                style="cursor: pointer;"
                              >
                                info
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Columns Graph -->
                    <div class="column">
                      <div
                        style="padding-top: 0.6% !important; margin: 0px !important;"
                      >
                        <div
                          class="has-text-centered content-nodata-graph"
                          :class="
                            rangoIntervencion(
                              filteredDataHistoric[vS.first],
                              v.first === 'RGO-09-Engagement' ? 1 : 0,
                            )
                          "
                          v-if="
                            !validateDataGraph(filteredDataHistoric[vS.first])
                          "
                        >
                          <span class="is-flex"
                            ><i class="material-icons">insert_chart</i>&nbsp;No
                            hay suficientes datos</span
                          >
                        </div>
                        <y-graph
                          v-if="
                            validateDataGraph(filteredDataHistoric[vS.first])
                          "
                          :datagraph="
                            createDataGraphHorizontalBar(
                              filteredDataHistoric[vS.first],
                              vS.title,
                            )
                          "
                          :cambio="cambio"
                          style="height: 65px !important;"
                        ></y-graph>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
          </div>
          <div v-else>
            <variables-prioritarias
              :frsm="frsm"
              :year="board.historic.selectYear"
              :regression="board.regression"
              :rango-fp="rangoFp"
              v-on:fetch="fetchRegressionFrp"
            ></variables-prioritarias>
          </div>
        </div>

        <div class="is-flex is-justify-center">
          <hr class="has-text-dark" style="width: 20%" />
          <h1
            class="title is-size-4"
            style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
          >
            Prioridad de Intervención en subgrupos
          </h1>
          <hr class="has-text-dark" style="width: 20%" />
        </div>

        <table-r
          ref="tableFrsm"
          :rowData="filteredTable"
          :limitSelection="table.limitSelection"
          :filters="board.filter"
          :permanentFilters="board.permanentFilters"
          @calculatePorcentage="calculatePorcentage"
          @setFilterTable="setFilterTable"
        ></table-r>
        <div
          v-if="
            filteredData['dataAdmin']['COMENTARIO'] && !this.$route.params.id
          "
        >
          <div style="margin-bottom: 40px;" class="is-flex is-justify-center">
            <hr class="has-text-dark" style="width: 20%" />
            <h1
              class="title is-size-4"
              style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
            >
              Comentarios
            </h1>
            <hr class="has-text-dark" style="width: 20%" />
          </div>

          <div style="height: 330px !important; overflow-y: scroll;">
            <div
              v-for="(v, k) in filteredData['dataAdmin']['COMENTARIO']"
              :key="k + 'comment'"
            >
              <div v-if="v['SubGrupo']">
                <article
                  class="media"
                  style="padding-bottom: 15px"
                  v-for="item in v['countData']['sum']"
                  :key="item"
                >
                  <figure class="media-left">
                    <p class="image">
                      <i class="material-icons is-size-1">account_box</i>
                    </p>
                  </figure>
                  <div class="media-content">
                    <div class="content">
                      <p>
                        <strong>Anónimo</strong>
                        <br />
                        {{ v.SubGrupo }}
                      </p>
                    </div>
                    <!-- <nav class="level is-mobile">
                      <div class="level-left">
                        <a class="level-item">
                          <span class="icon is-small"><i class="fas fa-reply"></i></span>
                        </a>
                        <a class="level-item">
                          <span class="icon is-small"><i class="fas fa-retweet"></i></span>
                        </a>
                        <a class="level-item">
                          <span class="icon is-small"><i class="fas fa-heart"></i></span>
                        </a>
                      </div>
                    </nav> -->
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>

      <menu-interpretacion
        v-if="board.inter.active"
        :data="board.inter.data"
        @closeMenuInter="closeMenuInter"
      ></menu-interpretacion>

      <div style="margin-top: 150px;">
        <CardProfessional :logo="true" />
      </div>

      <Pdf
        ref="pdfFrp"
        component="ReportFRP"
        :namePdf="'Reporte Frp - ' + frsm.nombre"
        :componentProps="{ frsm, header, data: { ...groups, ...efectos } }"
      />
    </section>
  </div>
</template>
<script>
import apiServices from "@/services/yungol-services";
import CardProfessional from "../reports/components/frp/CardProfessional.vue";
import json from "./interpretaciones.json";
import Pdf from "../reports/Pdf.vue";
import menuInterpretacion from "./components/menuInterpretacion.vue";
import menuFiltersHistoric from "./components/menuFiltersHistoric.vue";
import yGraph from "@/components/dashboard/GraphFrs.vue";
import Demographic from "./Demographic.vue";
import Benchmark from "./Benchmark.vue";
import tableR from "./table.vue";
import KpiCard from "../climan/components/kpiCard.vue";
import CriticalCasesCard from "./components/CriticalCasesCard.vue";
import VariablesPrioritarias from "./components/variables-prioritarias/VariablesPrioritarias.vue";
import { mapState } from "vuex";
import * as XLSX from "xlsx-js-style";

export default {
  name: "Resultados",
  data: function() {
    return {
      dona: {
        data: {
          labels: ["Sin datos"],
          datasets: [
            {
              data: [100],
              backgroundColor: ["#d4d5d3"],
              borderColor: ["#919191"],
              /* backgroundColor: [
              '#f4cdcd',
              '#facca5',
              '#fff2cc',
              '#d9ead3',
              '#a2c4c9',
              '#c8d9f7',
              '#a9d0ef',
              '#e8d2f5',
              '#e7c2e1',
              '#c2e7e7',
              '#fab9a5'
            ],
            borderColor: [
              '#f6adad',
              '#f6b884',
              '#f6db8a',
              '#c3eab5',
              '#88c1cb',
              '#a8c2ef',
              '#95c5ec',
              '#deb8f3',
              '#efb4e5',
              '#bbf5f5',
              '#f5a992'
            ], */
              borderWidth: 1,
            },
          ],
        },
        options: {
          legend: {
            display: true,
            position: "right",
          },
          responsive: true,
          resizeDelay: 0,
          plugins: {
            datalabels: {
              formatter: function(value, context) {
                return `${value}%`;
              },
              color: "white",
              font: {
                weight: "bold",
              },
            },
          },
        },
        type: "pie",
      },
      horizontalBar: {
        type: "horizontalBar",
        options: {
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
          },
          hover: {
            animationDuration: 0,
          },
          tooltips: {
            enabled: false,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  display: false,
                },
                scaleLabel: {
                  display: false,
                },
                gridLines: {
                  display: false,
                },
                stacked: true,
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  display: false,
                  beginAtZero: true,
                  max: 100,
                },
                stacked: true,
              },
            ],
          },
          legend: {
            position: "top",
            display: false,
          },
          animate: {},
          pointLabelFontFamily: "Quadon Extra Bold",
          scaleFontFamily: "Quadon Extra Bold",
          responsive: true,
          resizeDelay: 0,
          plugins: {
            datalabels: {
              formatter: function(value, context) {
                return `${value}%`;
              },
              textAlign: "start",
            },
          },
        },
        data: {
          labels: ["Data 1"],
          datasets: [
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
          ],
        },
      },
      bar: {
        type: "bar",
        options: {
          legend: {
            position: "top",
            display: false,
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  stepSize: 2,
                  maxTicksLimit: 5,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
          resizeDelay: 0,
        },
        data: {
          labels: [
            "Sin datos",
            "Sin datos",
            "Sin datos",
            "Sin datos",
            "Sin datos",
            "Sin datos",
          ],
          datasets: [
            {
              label: "Filtro sin datos",
              data: [0, 0, 0, 0, 0, 0],
              cornerRadius: 2,
              backgroundColor: [
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
                "#d4d5d3",
              ],
            },
          ],
        },
      },
      cambio: 1,
      config: {
        cuadrante: {
          name: "",
          drop: false,
          data: {},
          childrens: {},
        },
      },
      groups: {
        intraLaborales: {
          code: "RGO-02",
          title: "Intralaborales",
          first: "RGO-02-TOTAL FRP INTRALABORALES",
          active: false,
          sub2: {
            liderazgoRelacionesSociales: {
              code: "RGO-03",
              title: "Liderazgo y relaciones",
              first: "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
              active: false,
            },
            controlSobreElTrabajo: {
              code: "RGO-04",
              title: "Control sobre el trabajo",
              first: "RGO-04-CONTROL SOBRE EL TRABAJO",
              active: false,
            },
            demandasDelTrabajo: {
              code: "RGO-05",
              title: "Demandas del trabajo",
              first: "RGO-05-DEMANDAS DEL TRABAJO",
              active: false,
            },
            recompensas: {
              code: "RGO-06",
              title: "Recompensas",
              first: "RGO-06-RECOMPENSAS",
              active: false,
            },
          },
        },
        extraLaborales: {
          code: "RGO-07",
          title: "Extralaborales",
          first: "RGO-07-TOTAL FRP EXTRALABORALES",
          active: false,
        },
        indicadorCondicionesIndividuales: {
          code: "RGO-08",
          title: "Condiciones Individuales",
          first: "RGO-08-INDICADOR CONDICIONES INDIVIDUALES",
          active: false,
        },
      },
      efectos: {
        burnout: {
          title: "Burnout",
          code: "RGO-10",
          first: "RGO-10-Burnout",
          active: false,
        },
        estres: {
          title: "Estrés",
          code: "RGO-11",
          first: "RGO-11-Estrés",
          active: false,
        },
        engagement: {
          title: "Engagement",
          code: "RGO-09",
          first: "RGO-09-Engagement",
          active: false,
        },
      },
      header: {
        date: "",
        participation: "",
        surveyed: 0,
        notconset: 0,
      },
      table: {
        data: null,
        dataFilter: null,
        gridOptions: null,
        limitSelection: 1,
      },
      board: {
        dataAdmin: null,
        filter: null,
        permanentFilters: null,
        inter: {
          active: false,
          data: null,
        },
        historic: {
          filter: null,
          dataAdmin: {},
          dataFilter: {},
          dataGroups: [],
          years: null,
          selectYear: "",
        },
        demo: false,
        benchmark: false,
        efectosModo: "niveles",
        regression: {
          status: "idle",
          data: null,
          error: null,
        },
      },
      selects: {
        inputHistoric: "",
      },
      filterIsSticky: false,
      legendStuck: false,
      legendHeight: 0,
      inEfectosSection: false,
      interpretations: json,
    };
  },
  props: {
    frsm: Object,
  },
  computed: {
    ...mapState(["idtoken", "tokenUser", "isOculto"]),
    // Scope label shown above the results: the whole organization by default,
    // or the applied group filter(s) when the board is filtered.
    resultsScopeTitle: function() {
      const filter = this.board.filter;
      if (!filter || !filter.length) return "Toda la organización";
      const subgroups = filter.map((f) => f.subgr).filter(Boolean);
      return subgroups.length ? subgroups.join(", ") : "Toda la organización";
    },
    // La leyenda dockeada (flotando fija arriba) estorba mientras se mira
    // la Red/Sankey de Variables prioritarias — pero solo cuando de verdad
    // está dockeada (legendStuck). Si todavía está en su posición normal
    // del flujo (no se ha scrolleado lo suficiente para que se fije), no
    // hay nada que ocultar: no flota sobre nada.
    legendSuppressed: function() {
      return this.legendStuck && this.inEfectosSection && this.board.efectosModo === "variables";
    },
    filteredData: function() {
      if (this.board.filter) {
        return this.board;
      } else {
        return this.frsm;
      }
    },
    // Subtotales intralaborales por Forma (A/B): SIEMPRE población completa,
    // independiente de los filtros de grupo. Se leen de la fuente sin filtrar
    // (frsm), no de filteredData/board.
    formaIntra: function() {
      const dataAdmin = this.frsm && this.frsm.dataAdmin;
      return (dataAdmin && dataAdmin["FORMA-INTRA"]) || [];
    },
    // Periodicidad global de medición: la más exigente entre las formas
    // ("Un año" si alguna lo requiere; si no, "Dos años"). Se muestra una sola
    // vez en la cabecera de la tarjeta, no por forma.
    formaPeriodicidad: function() {
      if (!this.formaIntra.length) return "";
      return this.formaIntra.some((f) => f.periodicidad === "Un año")
        ? "Un año"
        : "Dos años";
    },
    formaInfoTooltip: function() {
      return `
        <div class="critical-criteria">
          <strong>Forma — Subtotal intralaboral por forma</strong>
          <p>Promedio del indicador intralaboral de cada forma de
          la encuesta (A/B), sobre toda la población.</p>
          <p>El nivel de riesgo usa los rangos por forma:</p>
          <ul>
            <li><b>Forma A:</b> Sin riesgo 0–19.7 · Bajo 19.8–25.8 · Medio 25.9–31.5 · Alto 31.6–38.0 · Muy alto 38.1–100</li>
            <li><b>Forma B:</b> Sin riesgo 0–20.6 · Bajo 20.7–26.0 · Medio 26.1–31.2 · Alto 31.3–38.7 · Muy alto 38.8–100</li>
          </ul>
          <p><b>Periodicidad:</b> "Un año" si alguna forma queda en riesgo alto o
          muy alto; de lo contrario "Dos años".</p>
        </div>`;
    },
    // Config del pie de Forma. Cuando se muestran los subtotales (con su propio
    // swatch de color), se oculta la leyenda del pie por redundante.
    formaDona: function() {
      const admin = (this.filteredData && this.filteredData["dataAdmin"]) || {};
      const responses = (this.frsm && this.frsm["responses"]) || {};
      const cfg = this.createDataGraphDona(
        admin["FORMA"] || admin["Forma"],
        responses["AGR-FORMA"] || responses["AGR-Forma"],
      );
      if (
        this.formaIntra.length &&
        cfg &&
        cfg.options &&
        cfg.options.legend
      ) {
        cfg.options.legend.display = false;
      }
      return cfg;
    },
    filteredTable: function() {
      if (this.board.filter && this.table.dataFilter) {
        return this.table.dataFilter;
      } else {
        return this.table.data;
      }
    },
    filteredDataHistoric: function() {
      const selectYear = this.board.historic.selectYear;
      const filterCheck = this.board.historic.filter || this.board.filter;
      const isYear = filterCheck
        ? filterCheck.filter((x) => x.gr === "AGR-year").length
        : false;
      if (selectYear.length && !!filterCheck && !isYear) {
        console.log("filter", this.board.historic.dataFilter);
        return this.board.historic.dataFilter;
      } else if (
        selectYear.length &&
        Object.keys(this.board.historic.dataAdmin).length
      ) {
        console.log("normal", !isYear);
        return this.board.historic.dataAdmin[selectYear];
      } else {
        console.log("nada");
        return {};
      }
    },
  },
  methods: {
    // Sticky legend: flag when the legend docks to the top so it can collapse
    // and cast a shadow. The observed sentinel sits just above the legend; its
    // root margin is offset by the filter banner's height (42px) when a filter
    // is active so the two fixed bars don't overlap.
    initLegendStickyObserver() {
      this.$nextTick(() => {
        if (this._legendObserver) {
          this._legendObserver.disconnect();
          this._legendObserver = null;
        }
        const sentinel = this.$refs.legendSentinel;
        if (!sentinel) return;
        const offset = this.board.filter ? 42 : 0;
        this._legendObserver = new IntersectionObserver(
          ([entry]) => {
            const stuck = !entry.isIntersecting;
            // Capture the in-flow height before the bar is pulled out (fixed),
            // so the placeholder wrapper holds the space and content doesn't jump.
            if (stuck && this.$refs.legendBar) {
              this.legendHeight = this.$refs.legendBar.offsetHeight;
            }
            this.legendStuck = stuck;
          },
          { threshold: 0, rootMargin: `-${offset}px 0px 0px 0px` },
        );
        this._legendObserver.observe(sentinel);
      });
    },
    // Oculta la leyenda dockeada mientras la sección Efectos está a la
    // vista y el modo activo es "variables" (Red/Sankey) — observa la caja
    // completa de Efectos, no un sentinel de 1px, así se mantiene oculta
    // durante todo el scroll dentro de esa sección y reaparece apenas se
    // sale de ella en cualquier dirección. El offset superior descuenta la
    // altura aproximada de la barra dockeada para no dispararse mientras
    // todavía queda tapada por ella.
    initEfectosSectionObserver() {
      this.$nextTick(() => {
        if (this._efectosObserver) {
          this._efectosObserver.disconnect();
          this._efectosObserver = null;
        }
        const box = this.$refs.efectosBox;
        if (!box) return;
        this._efectosObserver = new IntersectionObserver(
          ([entry]) => {
            this.inEfectosSection = entry.isIntersecting;
          },
          { threshold: 0, rootMargin: "-90px 0px -30% 0px" },
        );
        this._efectosObserver.observe(box);
      });
    },
    // Graphs
    // Color del pie por forma (mismo que dataset del dona), para el swatch.
    formaPieColor(subGrupo) {
      const map = { A: "#a9d0ef", B: "#e7c7fa" };
      return map[subGrupo] || "#e7c2e1";
    },
    createDataGraphDona(data, labels) {
      if (data && labels) {
        const dataDona = {
          data: {
            labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
            datasets: [
              {
                data: [12, 19, 3, 5, 2, 3],
                backgroundColor: [
                  "#f4cdcd",
                  "#facca5",
                  "#fff2cc",
                  "#d9ead3",
                  "#a2c4c9",
                  "#c8d9f7",
                  "#a9d0ef",
                  "#e8d2f5",
                  "#e7c2e1",
                  "#c2e7e7",
                  "#fab9a5",
                ],
                borderColor: [
                  "#f6adad",
                  "#f6b884",
                  "#f6db8a",
                  "#c3eab5",
                  "#88c1cb",
                  "#a8c2ef",
                  "#95c5ec",
                  "#deb8f3",
                  "#efb4e5",
                  "#bbf5f5",
                  "#f5a992",
                ],
                borderWidth: 1,
              },
            ],
          },
          options: {
            legend: {
              display: true,
              position: "right",
            },
            responsive: true,
            maintainAspectRatio: false,
            resizeDelay: 0,
            plugins: {
              datalabels: {
                formatter: function(value, context) {
                  if (value >= 3) return `${value}%`;
                  return "";
                },
                textAlign: "start",
                color: "#4a4a4a",
                font: {
                  size: 10,
                  weight: "bold",
                },
              },
            },
          },
          type: "pie",
        };

        const sumData = data
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        dataDona.data.labels = data
          .filter((x) => {
            if (x.SubGrupo) return true;
          })
          .map((x) => x.SubGrupo);

        dataDona.data.datasets[0].data = data
          .filter((x) => {
            if (x.SubGrupo) return true;
          })
          .map((x) => {
            return ((x["countData"]["sum"] * 100) / sumData).toFixed(1);
          });

        dataDona.data.datasets[0].backgroundColor = [
          "#a9d0ef",
          "#e7c7fa",
          "#e7c2e1",
        ];
        dataDona.data.datasets[0].borderColor = [
          "#95c5ec",
          "#deb8f3",
          "#efb4e5",
        ];

        return dataDona;
      }
      return this.dona;
    },
    createDataGraphBar(data, labels) {
      if (data && labels) {
        labels = labels.SubGrupo;
        labels = this.sortData(labels, false);
        data = labels.map((x) => {
          const value = data.filter((d) => d.SubGrupo === x);
          if (value.length) return value[0];
          return {
            Grupo: "Edad",
            SubGrupo: x,
            check: false,
            check2: false,
            countData: {
              sum: 0,
            },
          };
        });
        const dataBar = this.bar;

        dataBar.data.labels = labels.map((x) => x || "Sin subgrupo");
        dataBar.data.datasets[0].data = data.map((x) => x["countData"]["sum"]);

        dataBar.data.datasets[0].label = data[0].Grupo;
        dataBar.data.datasets[0].backgroundColor = "#a9d0ef";

        return dataBar;
      }
      return this.bar;
    },
    createDataGraphHorizontalBar: function(data, label) {
      if (data && label) {
        const dataHorizontalBar = {
          type: "horizontalBar",
          options: {
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              },
            },
            hover: {
              animationDuration: 0,
            },
            tooltips: {
              enabled: false,
              custom: function(tooltipModel) {
                // Tooltip Element
                let tooltipEl = document.getElementById("chartjs-tooltip");

                // Create element on first render
                if (!tooltipEl) {
                  tooltipEl = document.createElement("div");
                  tooltipEl.id = "chartjs-tooltip";
                  tooltipEl.innerHTML = "<table></table>";
                  tooltipEl.style.backgroundColor = "rgba(0,0,0,0.71)";
                  tooltipEl.style.borderRadius = "5%";
                  document.body.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                  tooltipEl.style.opacity = 0;
                  return;
                }

                // Set caret Position
                tooltipEl.classList.remove("above", "below", "no-transform");
                if (tooltipModel.yAlign) {
                  tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                  tooltipEl.classList.add("no-transform");
                }

                function getBody(bodyItem) {
                  return bodyItem.lines;
                }

                // Set Text
                if (tooltipModel.body) {
                  let titleLines = tooltipModel.title || [];
                  let bodyLines = tooltipModel.body.map(getBody);

                  let innerHtml = "<thead>";

                  titleLines.forEach(function(title) {
                    innerHtml +=
                      '<tr><th style="color: white;">' + title + "</th></tr>";
                  });
                  innerHtml += "</thead><tbody>";

                  bodyLines.forEach(function(body, i) {
                    let colors = tooltipModel.labelColors[i];
                    let style = "background:" + colors.backgroundColor;
                    style += "; border-color:" + colors.borderColor;
                    style += "; border-width: 2px";
                    let span = '<span style="' + style + '"></span>';
                    innerHtml +=
                      '<tr><td style="color: white;">' +
                      span +
                      body +
                      "%" +
                      "</td></tr>";
                  });
                  innerHtml += "</tbody>";

                  let tableRoot = tooltipEl.querySelector("table");
                  tableRoot.innerHTML = innerHtml;
                }

                // `this` will be the overall tooltip
                let position = this._chart.canvas.getBoundingClientRect();

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
                tooltipEl.style.position = "absolute";
                tooltipEl.style.left =
                  position.left +
                  window.pageXOffset +
                  tooltipModel.caretX +
                  "px";
                tooltipEl.style.top =
                  position.top +
                  window.pageYOffset +
                  tooltipModel.caretY +
                  "px";
                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                tooltipEl.style.padding =
                  tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
                tooltipEl.style.pointerEvents = "none";
              },
            },
            scales: {
              xAxes: [
                {
                  ticks: {
                    display: false,
                    beginAtZero: true,
                    max: 100,
                  },
                  scaleLabel: {
                    display: false,
                  },
                  gridLines: {
                    display: false,
                  },
                  stacked: true,
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  ticks: {
                    display: false,
                  },
                  stacked: true,
                },
              ],
            },
            legend: {
              position: "top",
              display: false,
            },
            animate: {},
            pointLabelFontFamily: "Quadon Extra Bold",
            scaleFontFamily: "Quadon Extra Bold",
            responsive: true,
            resizeDelay: 0,
            plugins: {
              datalabels: {
                formatter: function(value, context) {
                  if (value >= 3) return `${value}%`;
                  return "";
                },
                textAlign: "start",
              },
            },
          },
          data: {
            labels: ["Data 1"],
            datasets: [
              {
                label: "Dataset 1",
                data: [28],
                backgroundColor: ["#f4cdcd"],
              },
              {
                label: "Dataset 2",
                data: [45.7],
                backgroundColor: ["#facca5"],
              },
              {
                label: "Dataset 3",
                data: [65.9],
                backgroundColor: ["#fff2cc"],
              },
              {
                label: "Dataset 4",
                data: [72.4],
                backgroundColor: ["#d9ead3"],
              },
              {
                label: "Dataset 5",
                data: [32],
                backgroundColor: ["#c8d9f7"],
              },
            ],
          },
        };

        const sumData = data
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        let datasets = [];
        // Función que ordena la data a un formato fijo
        const orderData = (p, d) => {
          const postion = (df) => {
            datasets[df] = d;
          };

          switch (p) {
            case "Riesgo muy alto":
              postion(0);
              break;
            case "Riesgo alto":
              postion(1);
              break;
            case "Riesgo medio":
              postion(2);
              break;
            case "Riesgo bajo":
              postion(3);
              break;
            case "Sin riesgo o riesgo despreciable":
              postion(4);
              break;
            case "Sin riesgo o riesgo bajo":
              postion(5);
              break;
            case "Muy alto":
              postion(0);
              break;
            case "Alto":
              postion(1);
              break;
            case "Medio":
              postion(2);
              break;
            case "Bajo":
              postion(3);
              break;
            case "Muy bajo":
              postion(4);
              break;
            default:
              datasets.push(d);
              break;
          }
        };

        data
          .filter((x) => x.SubGrupo)
          .map((x) => {
            const d = {
              label: "Dataset",
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1,
            };
            const porcentage = this.calculatePorcentage(
              x["countData"]["sum"],
              sumData,
            );
            const rango = this.rangoFp(
              x.SubGrupo,
              x.Grupo === "RGO-09-Engagement" ? 1 : 0,
            );
            d.data.push(porcentage);
            d.label = x.SubGrupo;
            d.backgroundColor.push(rango.color);
            d.borderColor.push(rango.border);

            orderData(d.label, d);
          });

        dataHorizontalBar.data.labels = [label];
        dataHorizontalBar.data.datasets = datasets.filter((x) => {
          if (x) return true;
        });

        return dataHorizontalBar;
      }
      return this.horizontalBar;
    },
    validateDataGraph(data) {
      if (data) {
        let cont = 0;

        data.map((e) => {
          if (e.SubGrupo) cont++;
        });

        return !!cont;
      } else {
        return false;
      }
    },
    // Board
    showSubGroups(e, s = null) {
      if (!s) {
        if (!this.groups[e]) {
          this.efectos[e].active = !this.efectos[e].active;
        } else {
          this.groups[e].active = !this.groups[e].active;
        }
      } else {
        this.groups[e].sub2[s].active = !this.groups[e].sub2[s].active;
      }
    },
    recoverSubGroups() {
      const _this = this;

      const groups = this.groups;
      const efectos = this.efectos;
      // Se recuperan los subgrupos de cada variable principal
      for (const k in groups) {
        const el = _this.groups[k];
        if (k !== "intraLaborales") {
          _this.groups[k].sub = _this.getDataSubGroups(el.code, el.first);
        } else {
          for (const k2 in el.sub2) {
            const el2 = _this.groups[k].sub2[k2];
            _this.groups[k].sub2[k2].sub = _this.getDataSubGroups(
              el2.code,
              el2.first,
            );
          }
        }
      }
      // Se recuperan los subgrupos de cada efecto
      for (const k in efectos) {
        const el = _this.efectos[k];
        _this.efectos[k].sub = _this.getDataSubGroups(el.code, el.first);
      }
    },
    getDataSubGroups(e, f) {
      return Object.keys(this.filteredData.dataAdmin)
        .filter((x) => {
          if (x.toLowerCase().indexOf(e.toLowerCase()) > -1 && x !== f) {
            return true;
          }
        })
        .map((x) => {
          return { first: x, title: x.substr(7, x.length) };
        });
    },
    getDataHeader() {
      const _this = this;
      // Datos del header
      let conData = _this.filteredData["dataAdmin"]["CONSENTIMIENTO"];
      let totalCurrent = conData ? conData[0]["countData"]["sum"] : 0;

      this.header = {
        date: _this.dateToString(_this.frsm["created"])
          ? _this.dateToString(_this.frsm["created"])
          : "Sin Fecha especificada",
        surveyed: totalCurrent,
      };
    },
    getDataInter(data, title) {
      if (data) {
        this.board.inter.data = { data: data, title };
        this.board.inter.data.group = data[0].Grupo;
        this.board.inter.active = true;
      }
    },
    closeMenuInter() {
      this.board.inter.active = false;
    },
    showCtx() {
      this.board.benchmark = !this.board.benchmark;
    },
    showDemo() {
      this.board.demo = !this.board.demo;
    },
    isPermanentFilter(filter) {
      if (!this.board.permanentFilters) return false;

      const index = new Set(
        this.board.permanentFilters.map((f) => `${f.gr}__${f.subgr}`),
      );
      return index.has(`${filter.gr}__${filter.subgr}`);
    },
    // Board - Historic
    getDataSelectHistoric() {
      let years = this.frsm.responses["AGR-year"].SubGrupo;
      if (years) {
        years = years.map((el) => parseInt(el));
        years.sort(function(a, b) {
          return b - a;
        });
        years = years.filter((e) => {
          if (e && e.toString() !== years[0].toString()) return true;
        });

        if (years.length > 0) this.board.historic.years = years;
      }
    },
    deleteSelectionHistoric() {
      this.board.historic.selectYear = "";
      this.selects.inputHistoric = "";
      this.board.historic.filter = null;
      this.board.historic.dataFilter = {};
      this.$refs.menuGroupsHistoric.restartSelects();
      // this.deselectFilter();
      this.$store.dispatch("notify", {
        message: `Histórico del tablero eliminado correctamente`,
        type: "is-link",
      });
    },
    getGroupsHistoric() {
      const historic = this.board.historic;
      return historic.selectYear
        ? historic.dataGroups[historic.selectYear]
        : [];
    },
    async setFilterHistoric(filter) {
      if (filter.length) {
        const newFilter = filter.map((x) => {
          return { gr: `AGR-${x.group}`, subgr: x.value };
        });
        const query = {
          filtro: [...newFilter],
          idfrs: this.frsm.id,
        };
        query.filtro.push({
          gr: "AGR-year",
          subgr: this.board.historic.selectYear.toString(),
        });
        this.board.historic.dataFilter = (
          await apiServices.post(`/filtroinformefrspublic`, query)
        ).data;
        this.board.historic.filter = newFilter;
        this.cambio ? (this.cambio = 0) : (this.cambio = 1);
      }
    },
    async deleteFilterHistoric() {
      if (this.board.filter && Object.keys(this.board.filter).length) {
        const query = {
          filtro: [...this.board.filter],
          idfrs: this.frsm.id,
        };
        query.filtro.push({
          gr: "AGR-year",
          subgr: this.board.historic.selectYear.toString(),
        });
        this.board.historic.dataFilter = (
          await apiServices.post(`/filtroinformefrspublic`, query)
        ).data;
      }
      this.board.historic.dataFilter = {};
      this.board.historic.filter = null;
      this.cambio ? (this.cambio = 0) : (this.cambio = 1);
    },
    // Table Groups
    async getDataGroups() {
      try {
        // Se recuperan todos los grupos calculados
        const result = await apiServices.post(`/groupsfrp/${this.frsm.id}`, {
          filters: this.board.filter,
        });

        if (result.data) {
          this.table.data = result.data;
          this.table.limitSelection = Object.keys(result.data).length;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async setFilterTable(newFilter) {
      if (newFilter.length) {
        try {
          // Set Filters
          const filters = newFilter.map((x) => {
            return { gr: `AGR-${x.name}`, subgr: x.subGrupo };
          });
          if (
            !this.board.filter ||
            JSON.stringify(filters) !== JSON.stringify(this.board.filter)
          ) {
            // Get data of Board
            const query = {
              filtro: filters,
              idfrs: this.frsm.id,
            };
            const resultBoard = await apiServices.post(
              `/filtroinformefrspublic`,
              query,
            );
            this.board.dataAdmin = resultBoard.data;

            // Get data of historic
            if (this.board.historic.selectYear) {
              const query = {
                filtro: [...filters],
                idfrs: this.frsm.id,
              };
              query.filtro.push({
                gr: "AGR-year",
                subgr: this.board.historic.selectYear.toString(),
              });
              const resultFilter = await apiServices.post(
                `/filtroinformefrspublic`,
                query,
              );
              this.board.historic.dataFilter = resultFilter.data;
            }
            this.board.filter = filters;

            // Get data of table
            const resultTable = await apiServices.post(
              `/groupsfrp/${this.frsm.id}`,
              {
                filters: this.board.filter,
              },
            );
            this.table.dataFilter = resultTable.data;

            await this.$store.dispatch("notify", {
              message: `Filtro aplicado al tablero`,
              type: "is-link",
            });
          }
        } catch (e) {
          await this.$store.dispatch("notify", {
            message: `Error al aplicar el filtro al tablero`,
            type: "is-danger",
          });
        }
      } else {
        this.board.filter = null;
        if (this.board.historic.filter) {
          this.board.historic.filter = null;
          this.$refs.menuGroupsHistoric.restartSelects();
        }
        await this.$store.dispatch("notify", {
          message: `Filtro eliminado correctamente`,
          type: "is-link",
        });
      }
    },
    deselectFilter() {
      if (this.$route.params.id) return;
      this.$refs.tableFrsm.deselect();
    },
    deselectOne(filter) {
      this.$refs.tableFrsm.deselectOne([filter]);
    },
    // Excel
    widthCols(data) {
      let values = [];

      // Recorre todas las filas
      for (const currentRow of data) {
        currentRow.forEach((cell, columnIndex) => {
          const cellValueLength = String(cell || "").length + 2;

          if (
            !values[columnIndex] ||
            values[columnIndex].width < cellValueLength
          ) {
            values[columnIndex] = { width: cellValueLength };
          }
        });
      }

      // Validar los títulos (asumiendo que están en la primera fila)
      const headerRow = data[0] || [];
      headerRow.forEach((header, index) => {
        const headerLength = String(header || "").length + 2;
        if (values[index].width < headerLength) {
          values[index] = { width: headerLength };
        }
      });

      return values;
    },
    colLetterToIndex(letter) {
      let col = 0;
      for (let i = 0; i < letter.length; i++) {
        col *= 26;
        col += letter.charCodeAt(i) - 64;
      }
      return col - 1;
    },
    buildHeaders() {
      const riskLabels = [
        "Sin riesgo o riesgo despreciable",
        "Riesgo bajo",
        "Riesgo medio",
        "Riesgo alto",
        "Riesgo muy alto",
      ];
      const effectsLabels = ["Muy bajo", "Bajo", "Medio", "Alto", "Muy alto"];
      const engagementLabels = [
        "Muy alto",
        "Alto",
        "Medio",
        "Bajo",
        "Muy bajo",
      ];
      const criticalCasesLabels = [
        "Caso no crítico",
        "Caso medianamente crítico",
        "Caso crítico",
        "Caso muy crítico",
      ];

      const riskHeaders = [];

      let total = 195;
      let colIndexRisk = XLSX.utils.decode_col("E");

      for (let i = 0; i < total; i++) {
        const colLetter = XLSX.utils.encode_col(colIndexRisk + i);
        const label = riskLabels[i % riskLabels.length];

        riskHeaders.push({
          row: 3,
          from: colLetter,
          to: colLetter,
          value: label,
        });
      }

      total = 20;
      let colIndexEfects = XLSX.utils.decode_col("GR");

      for (let i = 0; i < total; i++) {
        const colLetter = XLSX.utils.encode_col(colIndexEfects + i);
        const label = effectsLabels[i % effectsLabels.length];

        riskHeaders.push({
          row: 3,
          from: colLetter,
          to: colLetter,
          value: label,
        });
      }

      total = 5;
      let colIndexEngag = XLSX.utils.decode_col("HL");

      for (let i = 0; i < total; i++) {
        const colLetter = XLSX.utils.encode_col(colIndexEngag + i);
        const label = engagementLabels[i % engagementLabels.length];

        riskHeaders.push({
          row: 3,
          from: colLetter,
          to: colLetter,
          value: label,
        });
      }

      total = 4;
      let colIndexCritical = XLSX.utils.decode_col("HQ");

      for (let i = 0; i < total; i++) {
        const colLetter = XLSX.utils.encode_col(colIndexCritical + i);
        const label = criticalCasesLabels[i % criticalCasesLabels.length];

        riskHeaders.push({
          row: 3,
          from: colLetter,
          to: colLetter,
          value: label,
        });
      }

      const encabezados = [
        // Fila 1
        { row: 1, from: "E", to: "DT", value: "CONDICIONES INTRALABORALES" },
        { row: 1, from: "DU", to: "FH", value: "CONDICIONES EXTRALABORALES" },
        { row: 1, from: "FI", to: "FM", value: "TOTAL FACTORES DE RIESGO" },
        { row: 1, from: "FN", to: "GL", value: "CONDICIONES INDIVIDUALES" },
        { row: 1, from: "GM", to: "HP", value: "EFECTOS" },
        { row: 1, from: "HQ", to: "HT", value: "CASOS CRÍTICOS" },
        { row: 1, from: "HU", to: "HV", value: "TOTAL INTRA TRANSFORMA" },

        // Fila 2
        { row: 2, from: "A", to: "B", value: "Grupos" },
        { row: 2, from: "E", to: "I", value: "Características del Liderazgo" },
        { row: 2, from: "J", to: "N", value: "Relaciones Sociales" },
        {
          row: 2,
          from: "O",
          to: "S",
          value: "Retroalimentación del Desempeño",
        },
        { row: 2, from: "T", to: "X", value: "Relación con los Colaboradores" },
        {
          row: 2,
          from: "Y",
          to: "AC",
          value: "LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
        },
        { row: 2, from: "AD", to: "AH", value: "Claridad de Rol" },
        { row: 2, from: "AI", to: "AM", value: "Capacitación" },
        {
          row: 2,
          from: "AN",
          to: "AR",
          value: "Participación y manejo del cambio",
        },
        {
          row: 2,
          from: "AS",
          to: "AW",
          value: "Oportunidades uso y dllo habilidades y conocimientos",
        },
        {
          row: 2,
          from: "AX",
          to: "BB",
          value: "Control y Autonomía sobre el trabajo",
        },
        { row: 2, from: "BC", to: "BG", value: "CONTROL SOBRE EL TRABAJO" },
        {
          row: 2,
          from: "BH",
          to: "BL",
          value: "Demandas ambientales y de esfuerzo físico",
        },
        { row: 2, from: "BM", to: "BQ", value: "Demandas emocionales" },
        { row: 2, from: "BR", to: "BV", value: "Demandas cuantitativas" },
        {
          row: 2,
          from: "BW",
          to: "CA",
          value: "Influencia trabajo entorno extralaboral",
        },
        {
          row: 2,
          from: "CB",
          to: "CF",
          value: "Exigencias de responsabilidad del cargo",
        },
        { row: 2, from: "CG", to: "CK", value: "Demandas de carga mental" },
        { row: 2, from: "CL", to: "CP", value: "Consistencia de Rol" },
        {
          row: 2,
          from: "CQ",
          to: "CU",
          value: "Demandas de la Jornada de Trabajo",
        },
        { row: 2, from: "CV", to: "CZ", value: "DEMANDAS DEL TRABAJO" },
        {
          row: 2,
          from: "DA",
          to: "DE",
          value:
            "Recompensas derivadas de la pertenencia a la organización y del trabajo que se realiza",
        },
        {
          row: 2,
          from: "DF",
          to: "DJ",
          value: "Reconocimiento y Compensación",
        },
        { row: 2, from: "DK", to: "DO", value: "RECOMPENSAS" },
        { row: 2, from: "DP", to: "DT", value: "TOTAL FRP INTRALABORALES" },
        { row: 2, from: "DU", to: "DY", value: "Tiempo Fuera del Trabajo" },
        { row: 2, from: "DZ", to: "ED", value: "Relaciones Familiares" },
        {
          row: 2,
          from: "EE",
          to: "EI",
          value: "Comunicación y relaciones interpersonales",
        },
        {
          row: 2,
          from: "EJ",
          to: "EN",
          value: "Situación económica del grupo familiar",
        },
        {
          row: 2,
          from: "EO",
          to: "ES",
          value: "Características de la vivienda y de su entorno",
        },
        {
          row: 2,
          from: "ET",
          to: "EX",
          value: "Influencia del entorno extralaboral sobre el trabajo",
        },
        {
          row: 2,
          from: "EY",
          to: "FC",
          value: "Desplazamiento vivienda-trabajo-vivienda",
        },
        { row: 2, from: "FD", to: "FH", value: "TOTAL FRP EXTRALABORALES" },
        { row: 2, from: "FI", to: "FM", value: "TOTAL FRP" },
        { row: 2, from: "FN", to: "FR", value: "Optimismo Vida" },
        { row: 2, from: "FS", to: "FW", value: "Internalidad" },
        { row: 2, from: "FX", to: "GB", value: "Autoestima" },
        { row: 2, from: "GC", to: "GG", value: "Autoeficacia" },
        {
          row: 2,
          from: "GH",
          to: "GL",
          value: "Indicador Condiciones Individuales",
        },
        { row: 2, from: "GM", to: "GQ", value: "Agotamiento emocional" },
        { row: 2, from: "GR", to: "GV", value: "Cinismo" },
        { row: 2, from: "GW", to: "HA", value: "Pérdida Autoeficacia" },
        { row: 2, from: "HB", to: "HF", value: "BURNOUT" },
        { row: 2, from: "HG", to: "HK", value: "Estrés" },
        { row: 2, from: "HL", to: "HP", value: "Engagement" },
        { row: 2, from: "HQ", to: "HT", value: "Casos críticos" },

        // Fila 3
        { row: 3, from: "A", to: "A", value: "Nivel 1" },
        { row: 3, from: "B", to: "B", value: "Nivel 2" },
        { row: 3, from: "C", to: "C", value: "Año" },
        { row: 3, from: "D", to: "D", value: "N" },
        {
          row: 3,
          from: "E",
          to: "E",
          value: "Sin riesgo o riesgo despreciable",
        },
        ...riskHeaders,
        { row: 3, from: "HU", to: "HU", value: "A" },
        { row: 3, from: "HV", to: "HV", value: "B" },
      ];

      const merges = [];
      const headerMatrix = [];

      const cellHeaderStyle = {
        font: { bold: true },
        alignment: { horizontal: "center", vertical: "center", wrapText: true },
      };

      for (let i = 0; i < 3; i++) headerMatrix.push([]);

      encabezados.forEach(({ row, from, to, value }) => {
        const r = row - 1;
        const start = this.colLetterToIndex(from);
        const end = this.colLetterToIndex(to);

        headerMatrix[r][start] = {
          v: value,
          t: "s",
          s: cellHeaderStyle,
        };

        if (start !== end) {
          merges.push({ s: { r, c: start }, e: { r, c: end } });
        }
      });

      return { riskLabels, headerMatrix, merges };
    },
    formatValues(structure, data, group) {
      const newData = [];
      const keysGroup = ["name", "subGrupo", "year", "n"];

      const getInfoGroup = (key) => {
        if (key === keysGroup[0]) return data[key] || this.frsm.nombre || "-";
        if (key === keysGroup[1]) return data[key] || "Perfil general";
        if (key === keysGroup[2]) return data.year[0].SubGrupo || "-";
        if (key === keysGroup[3]) return data.year[0].countData.sum || 0;
        return "-";
      };
      const getPositionRange = (group, key) => {
        const ranges = {
          normal: {
            0: [
              "Sin riesgo o riesgo despreciable",
              "Muy bajo",
              "Caso no crítico",
            ],
            1: ["Riesgo bajo", "Bajo", "Caso medianamente crítico"],
            2: ["Riesgo medio", "Medio", "Caso crítico"],
            3: ["Riesgo alto", "Alto", "Caso muy crítico"],
            4: ["Riesgo muy alto", "Muy alto"],
          },
          "RGO-09-Engagement": {
            0: ["Muy alto"],
            1: ["Alto"],
            2: ["Medio"],
            3: ["Bajo"],
            4: ["Muy bajo"],
          },
        };
        const groupRange =
          key === "RGO-09-Engagement" ? "RGO-09-Engagement" : "normal";
        let result = 0;

        for (const [key, value] of Object.entries(ranges[groupRange])) {
          if (value.includes(group.SubGrupo)) {
            result = key;
            break;
          }
        }

        return result;
      };
      const calculateRanges = (key) => {
        let rangesDefault = [0.0, 0.0, 0.0, 0.0, 0.0];
        if (key === "RGO-12-CASOS CRÍTICOS")
          rangesDefault = rangesDefault.slice(1);
        const values = data[key] || [];
        const sumData = values
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        // Variable sin ninguna respuesta válida: la fila queda en blanco en
        // el Excel (no "0,0%"), para no confundirla con un 0% real donde sí
        // hubo respuestas pero ninguna cayó en esa categoría.
        if (!sumData) return rangesDefault.map(() => null);

        values.map((x) => {
          if (!x.SubGrupo) return;
          const keyRange = getPositionRange(x, key);
          rangesDefault[keyRange] = (x["countData"]["sum"] * 100) / sumData;
        });

        return rangesDefault;
      };
      // TOTAL INTRA TRANSFORMA A/B: subtotal de la población completa, no por
      // subgrupo (ver formaIntraTransforma.js en el backend). Si la fila no
      // trae la key (subgrupos filtrados), queda en "-".
      const getFormaIntra = (forma) => {
        const rows = data["FORMA-INTRA"];
        const row = Array.isArray(rows) && rows.find((x) => x.SubGrupo === forma);
        return row && row.promedio != null ? row.promedio : "-";
      };

      structure.map((k) => {
        if (keysGroup.includes(k)) return newData.push(getInfoGroup(k));
        if (k === "TOTAL INTRA TRANSFORMA A") return newData.push(getFormaIntra("A"));
        if (k === "TOTAL INTRA TRANSFORMA B") return newData.push(getFormaIntra("B"));
        newData.push(...calculateRanges(k));
      });

      return newData;
    },
    getDataExcel() {
      const structure = [
        "name",
        "subGrupo",
        "year",
        "n",
        "RGO-03-Liderazgo",
        "RGO-03-Relaciones Sociales",
        "RGO-03-Retroalimentación",
        "RGO-03-Relación Colaboradores",
        "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
        "RGO-04-Claridad de Rol",
        "RGO-04-Capacitación",
        "RGO-04-Participación y cambio",
        "RGO-04-Habilidades y conocimientos",
        "RGO-04-Control y Autonomía",
        "RGO-04-CONTROL SOBRE EL TRABAJO",
        "RGO-05-Dem ambientales y fís",
        "RGO-05-Dem emocionales",
        "RGO-05-Dem cuantitativas",
        "RGO-05-Influencia trabajo entorno",
        "RGO-05-Exigencias cargo",
        "RGO-05-Demandas de carga mental",
        "RGO-05-Consistencia de Rol",
        "RGO-05-Dem Jornada de Trabajo",
        "RGO-05-DEMANDAS DEL TRABAJO",
        "RGO-06-Recompensas del trabajo",
        "RGO-06-Reconocimiento",
        "RGO-06-RECOMPENSAS",
        "RGO-02-TOTAL FRP INTRALABORALES",
        "RGO-07-Tiempo Fuera del Trabajo",
        "RGO-07-Relaciones Familiares",
        "RGO-07-Comunicación",
        "RGO-07-Economía Familiar",
        "RGO-07-Vivienda",
        "RGO-07-Influencia Entorno Trabajo",
        "RGO-07-Desplazamiento",
        "RGO-07-TOTAL FRP EXTRALABORALES",
        "RGO-01-TOTAL FRP",
        "RGO-08-Optimismo",
        "RGO-08-Internalidad",
        "RGO-08-Autoestima",
        "RGO-08-Autoeficacia",
        "RGO-08-INDICADOR CONDICIONES INDIVIDUALES",
        "RGO-10-Agotamiento Emocional",
        "RGO-10-Cinismo",
        "RGO-10-Pérdida de Autoeficacia",
        "RGO-10-Burnout",
        "RGO-11-Estrés",
        "RGO-09-Engagement",
        "RGO-12-CASOS CRÍTICOS",
        "TOTAL INTRA TRANSFORMA A",
        "TOTAL INTRA TRANSFORMA B",
      ];

      const data = this.board.dataAdmin ? this.board.dataAdmin : this.frsm;
      const groups = this.table.data
        ? this.table.data.filter((x) => !x.empty)
        : [];

      const newData = [data.dataAdmin, ...groups].map((d) =>
        this.formatValues(structure, d),
      );

      return newData;
    },
    getCommentsSheet() {
      const comentarios = this.filteredData.dataAdmin.COMENTARIO || [];
      const rows = [];
      comentarios
        .filter((v) => v.SubGrupo)
        .forEach((v) => {
          for (let i = 0; i < v.countData.sum; i++) {
            rows.push([v.SubGrupo]);
          }
        });

      return [["Comentario"], ...rows];
    },
    async downloadData() {
      try {
        const { headerMatrix, merges } = this.buildHeaders();
        const data = this.getDataExcel();
        const finalSheet = [...headerMatrix, ...data];
        const ws = XLSX.utils.aoa_to_sheet(finalSheet);
        const range = XLSX.utils.decode_range(ws["!ref"]);
        ws["!merges"] = merges;

        /* const isMergedCell = (row, col) => {
          return merges.find(
            (m) => row >= m.s.r && row <= m.e.r && col >= m.s.c && col <= m.e.c
          );
        }; */

        for (let R = 0; R <= range.e.r; ++R) {
          for (let C = 0; C <= range.e.c; ++C) {
            const cellAddress = { c: C, r: R };
            const cellRef = XLSX.utils.encode_cell(cellAddress);
            const cell = ws[cellRef];
            const styleCenterCell = {
              alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true,
              },
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } },
              },
            };
            if (!cell) {
              /* if (isMergedCell(R, C)) {
                ws[cellRef] = { t: "s", v: "" };
                cell = ws[cellRef];
              } else {
                continue;
              } */
              continue;
            }

            if (cell.v === undefined || cell.v === null || cell.v === "")
              continue;

            if (R >= 3) {
              if (C <= XLSX.utils.decode_col("C")) {
                // Columnas A a C
                cell.t = "s";
                cell.s = styleCenterCell;
              } else if (C === XLSX.utils.decode_col("D")) {
                // Columna D
                cell.t = "n";
                cell.s = styleCenterCell;
              } else if (
                C >= XLSX.utils.decode_col("E") &&
                C <= XLSX.utils.decode_col("HT")
              ) {
                // Columnas E a HT
                cell.t = "n";
                cell.z = "#,##0.0\\%";
                cell.s = styleCenterCell;
              } else if (
                C >= XLSX.utils.decode_col("HU") &&
                C <= XLSX.utils.decode_col("HV")
              ) {
                // Columnas HU a HV (TOTAL INTRA TRANSFORMA A/B): promedio
                // plano, sin formato de porcentaje.
                cell.t = "n";
                cell.s = styleCenterCell;
              }
            } else {
              cell.s = styleCenterCell;
            }
          }
        }

        ws["!freeze"] = { xSplit: 0, ySplit: 3 };
        ws["!cols"] = this.widthCols(finalSheet.slice(2));

        const commentsData = this.getCommentsSheet();
        const wsComentarios = XLSX.utils.aoa_to_sheet(commentsData);
        wsComentarios["!cols"] = this.widthCols(commentsData);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Reporte");
        XLSX.utils.book_append_sheet(wb, wsComentarios, "Comentarios");
        XLSX.writeFile(wb, `Resultados-${this.frsm.nombre}.xlsx`);
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    },
    // Helpers
    sortData(data, object = false) {
      if (data) {
        if (object) {
          data = data.filter((e) => {
            if (e.SubGrupo) {
              return true;
            }
            return false;
          });
          return data.slice().sort(function(a, b) {
            const nameA = a.SubGrupo.toUpperCase(); // ignore upper and lowercase
            const nameB = b.SubGrupo.toUpperCase(); // ignore upper and lowercase

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
        }
        return data.slice().sort();
      }
      return data;
    },
    dateToString(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "long", day: "numeric" };
      date = date.toLocaleDateString("es-CO", options);
      return date;
    },
    calculatePorcentage(v, sum) {
      return ((v * 100) / sum).toFixed(1);
    },
    rangoIntervencion(p, type = 0) {
      if (p) {
        let result = "";
        // Se suma todos los valores
        const sum = p
          .map((x) => {
            if (x.SubGrupo) return x["countData"]["sum"];
            return 0;
          })
          .reduce((a, b) => a + b, 0);

        // Objecto con estructura organizada
        let porcentageGroups = null;

        if (type === 0) {
          porcentageGroups = {
            alta1: {
              groups: ["Riesgo alto", "Riesgo muy alto", "Muy alto", "Alto"],
              sum: 0,
            },
            media: {
              groups: [
                "Riesgo medio",
                "Riesgo alto",
                "Riesgo muy alto",
                "Alto",
                "Muy alto",
                "Medio",
              ],
              sum: 0,
            },
            destacado: {
              groups: [
                "Sin riesgo o riesgo despreciable",
                "Riesgo bajo",
                "Sin riesgo o riesgo bajo",
                "Factor protector",
                "Bajo",
                "Muy bajo",
              ],
              sum: 0,
            },
          };
        } else if (type === 1) {
          porcentageGroups = {
            alta1: {
              groups: ["Bajo", "Muy bajo"],
              sum: 0,
            },
            media: {
              groups: ["Bajo", "Muy bajo", "Medio"],
              sum: 0,
            },
            destacado: {
              groups: ["Muy alto", "Alto"],
              sum: 0,
            },
          };
        }
        // Se saca la suma para la estrucutura solicitada
        p.map((e) => {
          const sub = !e.SubGrupo ? "" : String(e.SubGrupo);

          if (porcentageGroups.alta1["groups"].includes(sub)) {
            porcentageGroups.alta1.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum),
            );
          }
          if (porcentageGroups.media["groups"].includes(sub)) {
            porcentageGroups.media.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum),
            );
          }
          if (porcentageGroups.destacado["groups"].includes(sub)) {
            porcentageGroups.destacado.sum += parseFloat(
              this.calculatePorcentage(e["countData"]["sum"], sum),
            );
          }
        });

        // Se calcula el porcentage para cada elemento del objeto anterior y retornar un rango
        for (const k in porcentageGroups) {
          const porcentage = porcentageGroups[k]["sum"].toFixed(2);

          if (k === "alta1" && porcentage >= 30.0) {
            result = "bg-alta";
            break;
          } else if (k === "media" && porcentage >= 40.0) {
            result = "bg-media";
            break;
          } else if (k === "destacado" && porcentage >= 60.0) {
            result = "bg-destacado";
            break;
          } else if (porcentage < 30.0) {
            result = "bg-sinrango";
          }
        }
        return result;
      }
      return "bg-sinrango";
    },
    rangoFp: function(p, type = 0) {
      const rangos = {
        rango0: [
          "Riesgo muy alto",
          "Insatisfacción muy alta",
          "Presentación muy alta de sintomas",
          "Muy alto",
        ], // muy alta
        rango1: [
          "Riesgo alto",
          "Insatisfacción alta",
          "Presentación alta de sintomas",
          "Alto",
        ], // alta
        rango2: [
          "Riesgo medio",
          "Satisfacción muy alta",
          "Presentación media de sintomas",
          "Medio",
        ], // medio
        rango3: [
          "Riesgo bajo",
          "Satisfacción alta",
          "Presentación baja de sintomas",
          "Bajo",
        ], // bajo
        rango4: [
          "Sin riesgo o riesgo despreciable",
          "Sin riesgo o riesgo bajo",
          "Satisfacción baja",
          "Presentación muy baja de sintomas o sin presencia de ellos",
          "Muy bajo",
        ], // sin riesgo o muy bajo
      };
      if (rangos.rango0.includes(p)) {
        if (type === 1) {
          return {
            color: "#c8d9f7",
            border: "#a8c2ef",
          };
        }
        return {
          color: "#f4cdcd",
          border: "#f6adad",
        };
      } else if (rangos.rango1.includes(p)) {
        if (type === 1) {
          return {
            color: "#d9ead3",
            border: "#c3eab5",
          };
        }
        return {
          color: "#facca5",
          border: "#f6b884",
        };
      } else if (rangos.rango2.includes(p)) {
        return {
          color: "#fff2cc",
          border: "#f6db8a",
        };
      } else if (rangos.rango3.includes(p)) {
        if (type === 1) {
          return {
            color: "#facca5",
            border: "#f6b884",
          };
        }
        return {
          color: "#d9ead3",
          border: "#c3eab5",
        };
      } else if (rangos.rango4.includes(p)) {
        if (type === 1) {
          return {
            color: "#f4cdcd",
            border: "#f6adad",
          };
        }
        return {
          color: "#c8d9f7",
          border: "#a8c2ef",
        };
      } else {
        return {
          color: "#e1e1e1",
          border: "#c2c0c0",
        };
      }
    },
    // Others
    scrollTop() {
      const top = document.body.scrollHeight;
      window.scrollTo(top, 0);
    },
    createBodyTooltipInter(group) {
      if (this.interpretations[group.first]) {
        return `<div><h2 class='has-text-centered is-size-5 has-text-weight-bold'>${
          this.interpretations[group.first].title
        }</h2><br><p>${this.interpretations[group.first]["def"]}</p>${
          group.first !== "EFECTOS"
            ? "<br><span class='is-size-7 has-text-weight-bold'>Clic para ver más.</span>"
            : ""
        }</div>`;
      } else {
        return `<div><h2 class='has-text-centered is-size-5 has-text-weight-bold'>Error en los datos</h2><br><p>Por favor revisa que los datos estén correctos, posiblemente no se ingresó correctamente el nombre de la columna.</p><br><span class="has-text-weight-bold">Error en la columna ${group.first}</span></div>`;
      }
    },
    async copyLink(filter = null) {
      let textArea = document.createElement("textarea");

      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textArea.style.width = "2em";
      textArea.style.height = "2em";

      // We don't need padding, reducing the size if it does flash render.
      textArea.style.padding = 0;

      // Clean up any borders.
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";

      // Avoid flash of the white box if rendered for any reason.
      textArea.style.background = "transparent";

      let data = {};
      const allFilters = {
        board: this.board.filter,
        historic: this.board.historic.filter,
        yearHistoric: this.board.historic.selectYear,
      };
      filter = filter ? JSON.stringify(filter) : JSON.stringify(allFilters);

      const encodeFilter = btoa(filter); // Para descifrarlo es con atob()

      data.report = this.frsm.id;
      data.filter = btoa(encodeFilter); // Se vuelve a cifrar

      // let result = await apiServices.post('createviewclima', data);
      textArea.value =
        window.location.host + "/frp/share/" + data.report + "/" + data.filter;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        let successful = document.execCommand("copy");
        let msg = successful ? "¡Copiado al portapapeles!" : "Error al copiar";
        let type = successful ? "is-link" : "is-danger";

        await this.$store.dispatch("notify", {
          message: msg,
          type: type,
        });
      } catch (err) {
        await this.$store.dispatch("notify", {
          message: "Error al copiar",
          type: "is-danger",
        });
      }
      document.body.removeChild(textArea);
    },
    async downloadReport() {
      try {
        if (this.board.historic.selectYear) this.deleteSelectionHistoric();
        if (this.board.filter) this.deselectFilter();
        await this.$nextTick();
        setTimeout(() => {
          this.$refs.pdfFrp.downloadPdf();
        }, 2000);
      } catch (err) {
        console.error("Error downloading PDF:", err);
      }
    },
    async fetchRegressionFrp() {
      if (
        this.board.regression.status === "loading" ||
        this.board.regression.status === "success"
      )
        return;
      this.board.regression.status = "loading";
      this.board.regression.error = null;
      try {
        const year = this.board.historic.selectYear;
        const url =
          `/frp/${this.frsm.id}/regression` +
          (year ? `?year=${Number(year)}` : "");
        const result = await apiServices.get(url);
        if (result && result.data && result.data.results) {
          this.board.regression.data = result.data;
          this.board.regression.status = "success";
        } else {
          this.board.regression.status = "error";
          this.board.regression.error =
            "El análisis no pudo cargarse: la respuesta no tiene el formato esperado.";
        }
      } catch (err) {
        this.board.regression.status = "error";
        this.board.regression.error =
          "El análisis no pudo cargarse. Intenta de nuevo más tarde.";
      }
    },
  },
  created() {
    if (this.idtoken) {
    }
  },
  components: {
    yGraph,
    tableR,
    menuInterpretacion,
    Demographic,
    Benchmark,
    menuFiltersHistoric,
    CardProfessional,
    Pdf,
    KpiCard,
    CriticalCasesCard,
    VariablesPrioritarias,
  },
  beforeMount: async function() {
    if (window.location.host === "localhost:8080") {
      console.log(this.frsm);
    }
    const _this = this;

    if (!this.isOculto) {
      this.$store.commit("ocultarSide");
    }

    if (this.frsm.newFilter) {
      const newFilter = this.frsm.newFilter;
      this.board.dataAdmin = newFilter;
      this.board.filter = newFilter.allFilters["board"];
      this.board.permanentFilters = newFilter.allFilters["board"];
      if (newFilter.allFilters["historic"])
        this.board.historic.filter = newFilter.allFilters["historic"];
      if (parseInt(newFilter.allFilters["yearHistoric"]))
        this.selects.inputHistoric = parseInt(
          newFilter.allFilters["yearHistoric"],
        );
    }

    await _this.getDataGroups();

    _this.recoverSubGroups();
    _this.getDataHeader();
    _this.getDataSelectHistoric();
  },
  mounted() {
    this.initLegendStickyObserver();
    this.initEfectosSectionObserver();
  },
  beforeDestroy() {
    if (this._legendObserver) this._legendObserver.disconnect();
    if (this._efectosObserver) this._efectosObserver.disconnect();
  },
  errorCaptured(err, vm, info) {
    console.log({ err, vm, info });
    /* this.$store.dispatch("notify", {
      message: `Hubo un error al cargar el Tablero, intenta de nuevo o reporta este error`,
      type: "is-danger",
    }); */
  },
  watch: {
    "board.efectosModo": function(nv) {
      if (
        nv === "variables" &&
        (this.board.regression.status === "idle" ||
          this.board.regression.status === "error")
      ) {
        this.fetchRegressionFrp();
      }
    },
    "board.filter": function(nv) {
      // if (!this.$route.params.id) {
      this.closeMenuInter();
      this.recoverSubGroups();
      this.getDataHeader();
      this.cambio ? (this.cambio = 0) : (this.cambio = 1);
      // Re-arm the sticky observer: the banner's height changes the offset, and
      // toggling the filter re-renders the legend node being observed.
      this.initLegendStickyObserver();
      // this.scrollTop()
      // }
    },
    "board.demo": function() {
      this.initLegendStickyObserver();
    },
    "board.benchmark": function() {
      this.initLegendStickyObserver();
    },
    "selects.inputHistoric": async function(nv) {
      const _this = this;
      const year = nv;
      if (year !== "") {
        try {
          // Válida si los datos ya están guardados, si es asi los retorna rapidamente
          if (
            _this.board.historic.dataAdmin[year] &&
            _this.board.historic.dataGroups[year] &&
            !(this.board.filter && Object.keys(this.board.filter).length)
          ) {
            _this.board.historic.selectYear = year.toString();
            await this.$store.dispatch("notify", {
              message: `Histórico aplicado al tablero`,
              type: "is-link",
            });
            this.cambio ? (this.cambio = 0) : (this.cambio = 1);
            // this.table.limitSelection = 2;
          } else {
            const result = await apiServices.post(
              `/groupsfrp/${_this.frsm.id}/${year}`,
              {
                filters: this.board.filter,
              },
            );
            if (result.data) {
              const dataAdmin = result.data.filter((e) => {
                if (e.name === "year" && e.subGrupo === year.toString())
                  return true;
              })[0];
              if (dataAdmin) {
                _this.board.historic.selectYear = year.toString();
                _this.board.historic.dataAdmin[year] = dataAdmin;
                _this.board.historic.dataGroups[year] = result.data
                  .map((x) => {
                    return { value: x.subGrupo, active: false, group: x.name };
                  })
                  .filter((x) => x.value !== "null" && x.group !== "year");

                if (
                  this.board.filter &&
                  Object.keys(this.board.filter).length
                ) {
                  const query = {
                    filtro: [...this.board.filter],
                    idfrs: this.frsm.id,
                  };
                  query.filtro.push({ gr: "AGR-year", subgr: year.toString() });
                  _this.board.historic.dataFilter = (
                    await apiServices.post(`/filtroinformefrspublic`, query)
                  ).data;
                }

                await this.$store.dispatch("notify", {
                  message: `Histórico aplicado al tablero`,
                  type: "is-link",
                });

                this.cambio ? (this.cambio = 0) : (this.cambio = 1);
                // this.table.limitSelection = 2;
              } else {
                throw new Error(
                  "¡Ups! No se pudo extraer los Datos principales",
                );
              }
            }
          }
        } catch (e) {
          this.board.historic.selectYear = "";
          this.selects.inputHistoric = "";
          await this.$store.dispatch("notify", {
            message: `Error al aplicar el histórico al tablero`,
            type: "is-danger",
          });
          console.log(e);
        }
      }
    },
  },
};
</script>

<style lang="scss">
// Range 1
.bg-muyAlto {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
.bg-alto {
  background-color: #facca5;
  border: solid 1px #f6b884;
}
.bg-bajo {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-noRiesgo {
  background-color: #c8d9f7;
  border: solid 1px #a8c2ef;
}
// Range 1.1
.bg-muyAltoEng {
  background-color: #c8d9f7;
  border: solid 1px #a8c2ef;
}
.bg-altoEng {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-bajoEng {
  background-color: #facca5;
  border: solid 1px #f6b884;
}
.bg-noRiesgoEng {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
// Range 2
.bg-alta {
  background-color: #f4cdcd;
  border: solid 1px #f6adad;
}
.bg-media {
  background-color: #fff2cc;
  border: solid 1px #f6db8a;
}
.bg-destacado {
  background-color: #d9ead3;
  border: solid 1px #c3eab5;
}
.bg-sinrango {
  background-color: #eceeec;
  border: solid 1px #d4d5d3;
}
// Color icons
.bg-alta .icon-dash {
  background-color: #f6adad;
  border-radius: 50%;
}
.bg-media .icon-dash {
  background-color: #f6db8a;
  border-radius: 50%;
}
.bg-destacado .icon-dash {
  background-color: #c3eab5;
  border-radius: 50%;
}
.bg-sinrango .icon-dash {
  background-color: #d4d5d3;
  border-radius: 50%;
}
// Table
#table-1 {
  border-collapse: collapse;
  border-radius: 1em;
  overflow: hidden;
}
#table-2 {
  border-collapse: collapse;
  border-radius: 1em;
  overflow: hidden;
}
#table-1 tr {
  width: 100% !important;
  text-align: center !important;
}
#table-2 tr {
  width: 100% !important;
  text-align: center !important;
}
/* Round the end segments themselves so their 1px border follows the curve,
   instead of being sliced off by the table's overflow:hidden corner mask. */
#table-1 tr:first-child,
#table-2 tr:first-child {
  border-top-left-radius: 1em;
  border-bottom-left-radius: 1em;
}
#table-1 tr:last-child,
#table-2 tr:last-child {
  border-top-right-radius: 1em;
  border-bottom-right-radius: 1em;
}

.border {
  border-collapse: collapse;
  border-radius: 1em;
  overflow: hidden;
}

.message {
  background-color: #fafafa;
}

.is-blue {
  background-color: #a8c2ef !important;
  color: white !important;
}

.titleC {
  text-overflow: ellipsis !important;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  display: inline-block;
  text-transform: initial;
}

.contentTooltipInter {
  max-width: 20% !important;
  min-width: 10% !important;
}

.contentTooltipRangeInter {
  max-width: 30% !important;
  min-width: 10% !important;
  text-align: center !important;
}

.content-historic {
  margin-top: -45px;
  opacity: 0.5;
}
.content-historic .titleC {
  font-size: 14px !important;
}
.content-historic .material-icons {
  font-size: 18px !important;
}

.content-nodata-graph {
  width: 100%;
  padding: 5px;
  font-weight: bold;
  margin-top: 1%;
  margin-bottom: 1%;
  margin-left: 0.6%;
}
.content-nodata-graph span {
  justify-content: center;
}
.content-nodata-graph .material-icons {
  margin: auto 0 auto 0;
}

/* Active filter banner: fixed to the top of the content area (right of the
   sidebar) so it stays visible no matter how far the board is scrolled. */
.frp-filter-banner {
  position: fixed;
  top: 0;
  right: 0;
  /* left is bound inline to the sidebar width (open 250px / collapsed 68px);
     combined with right: 0 + margin auto + max-width it centers over the
     main content and matches the container width. */
  z-index: 200;
  margin-left: auto;
  margin-right: auto;
  max-width: 1344px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 14px;
  background: #f3e8ff;
  border: 1px solid #d9c2f0;
  border-top: none;
  border-radius: 0 0 10px 10px;
  color: #4a148c;
  box-shadow: 0 2px 6px rgba(10, 10, 10, 0.12);
}

@media (max-width: 768px) {
  .frp-filter-banner {
    left: 68px !important;
  }
}

/* Reserves the banner's height so page content is not hidden under it. */
.frp-board-filtered {
  padding-top: 42px;
}

.frp-filter-banner-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12.5px;
  white-space: nowrap;
  color: #522687;
}

.frp-filter-banner-label .material-icons {
  font-size: 16px;
}

.frp-filter-banner-clear {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: 1px solid #522687;
  color: #522687;
  border-radius: 4px;
  padding: 2px 10px;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;
}

.frp-filter-banner-clear:hover {
  background: #522687;
  color: #fff;
}

.frp-filter-banner-clear .material-icons {
  font-size: 15px;
}

.frp-filter-banner-items {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: thin;
  padding-bottom: 2px;
}

.frp-filter-banner-items::-webkit-scrollbar {
  height: 4px;
}

.frp-filter-chip {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 5px 2px 11px;
  background: #fff;
  border: 1px solid #d9c2f0;
  border-radius: 999px;
  font-size: 12px;
  line-height: 1.5;
}

.frp-filter-chip-group {
  color: #8268a8;
  font-weight: 600;
  font-size: 10px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.frp-filter-chip-sub {
  color: #3d1466;
  font-weight: 700;
}

.frp-filter-chip-delete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #a78bc7;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}

.frp-filter-chip-delete:hover {
  background: #f4dada;
  color: #c0392b;
}

.frp-filter-chip--historic {
  border-color: #b9d0f0;
}

.frp-filter-chip--historic .frp-filter-chip-group {
  color: #3a6bb0;
}

.frp-filter-chip--historic .frp-filter-chip-sub {
  color: #1c4587;
}

.frp-filter-vs {
  font-weight: 700;
  font-size: 12px;
  color: #7a7a7a;
  padding: 0 2px;
}

.frp-slide-down-enter-active,
.frp-slide-down-leave-active {
  transition: all 0.2s ease;
}

.frp-slide-down-enter,
.frp-slide-down-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.tooltip {
  z-index: 55 !important;
}

.title-card {
  border-radius: 10px !important;
  background-color: #f3f3f3 !important;
}

/* Header redesign (climan-style): title on the left, date on the right. */
.title-card .hero-body {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 1.5rem 2rem;
}

.title-card .hero-body .container {
  flex: 1 1 auto;
  width: auto;
  margin: 0;
}

.frp-header-date {
  text-align: right;
  white-space: nowrap;
}

.frp-header-date span {
  display: block;
  font-size: 0.7rem;
  color: #8a8a8a;
}

.frp-header-date h4 {
  font-size: 1.15rem;
  
  margin: 0;
}

/* Compact action buttons. */
.frp-header-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}

.frp-header-actions .button {
  gap: 6px;
}

.frp-header-actions .button .material-icons {
  font-size: 18px;
}

/* Invert the ranking SVG so it reads as white on the dark button. */
.btn-benchmark-icon {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

.radius-6 {
  border-radius: 6px !important;
}

/* Quadrant cards: same look as the Encuestados KpiCard, with the climan
   card shadow so every card in the row matches. */
.frp-quadrants {
  margin-top: 18px;
}

/* Force the row to flex with equal-height columns on desktop (don't rely on
   Bulma doing it). Scoped to >=769px so columns still stack on mobile. */
@media screen and (min-width: 769px) {
  .frp-quadrants {
    display: flex;
    align-items: stretch;
  }
}

/* Each column is a flex column so its card can grow to the full column height. */
.frp-quadrants .column {
  display: flex;
  flex-direction: column;
}

.frp-quadrants .box {
  width: 100%;
  /* flex-grow makes the box fill the (equal-height) column. The KpiCard's own
     height:100% otherwise disables stretch and leaves it short. */
  flex: 1 1 auto;
  height: 205px !important;
  border: none !important;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1) !important;
  /* Flex column so the header/divider margins don't collapse — matches the
     KpiCard and Casos críticos cards, so all three dividers align. */
  display: flex;
  flex-direction: column;
}

/* Cuando la tarjeta Forma muestra los subtotales por forma, deja crecer las
   tres tarjetas: la más alta (Forma) fija la altura de la fila y el resto se
   estira por align-items:stretch. Sin esto, las filas se salen del box de 205px. */
.frp-quadrants.has-forma-intra .box {
  /* height:100% + la fila con align-items:stretch iguala las tres tarjetas a
     la más alta (Casos críticos); min-height evita que encojan si todas caben. */
  height: 100% !important;
  min-height: 205px;
}

/* Encuestados card only: keep the header at the top, but center the value +
   subtitle in the remaining space via auto margins. */
.frp-encuestados-kpi {
  display: flex;
  flex-direction: column;
}

.frp-encuestados-kpi .kpi-header {
  justify-content: center;
}

.frp-encuestados-kpi .kpi-values {
  /* Centrar el valor + subtítulo como bloque (sube el 301 respecto al margen
     fijo anterior y deja espacio para que el subtítulo envuelva en 2 líneas). */
  margin-top: auto !important;
  margin-bottom: 0.35rem !important;
  justify-content: center;
}

.frp-encuestados-kpi .kpi-values + p {
  margin-top: 0 !important;
  margin-bottom: auto;
  text-align: center;
  /* Permitir que "Respondieron la encuesta" envuelva en vez de truncarse. */
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  line-height: 1.25;
}

/* Shorter chart so the graph cards land near the Encuestados card height;
   flex stretch then equalizes all three. */
/* Match the quadrant/KpiCard shadow so the graph cards (Edad, Forma, …) and the
   full-width section cards sit on the same elevation as the rest of the board
   instead of Bulma's faint default. */
.frp-graph-card,
.frp-section-card {
  border: none !important;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1) !important;
}

/* Header de "Efectos": título a la izquierda, toggle de modo a la derecha,
   con una sola línea divisoria arriba (Artifact `.eff-header`) — no el
   patrón <hr>+título+<hr> centrado que usan otros títulos de esta página,
   que no deja espacio para un control al lado. */
.frp-efectos-header {
  border-top: 1px solid #ddd;
  padding-top: 20px;
  margin: 30px 0 16px;
  flex-wrap: wrap;
  gap: 16px;
}

.frp-efectos-modo {
  display: inline-flex;
  align-items: center;
  background: #f3f3f3;
  border-radius: 999px;
  padding: 3px;
  gap: 2px;
}

.frp-efectos-modo__opt {
  padding: 7px 16px;
  border-radius: 999px;
  border: none;
  background: none;
  color: #6a6a6a;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
}

.frp-efectos-modo__opt--active {
  background: #510087;
  color: #fff;
}

/* Docking legend (Prioridad de intervención + Niveles de riesgo).
   A 1px sentinel above it drives the .is-stuck state via IntersectionObserver.
   Once docked the bar is pinned with position:fixed (same technique as the
   filter banner, which is reliable in this layout), while the .frp-legend-wrap
   placeholder reserves its height so the content below doesn't jump. */
.frp-legend-sentinel {
  height: 1px;
  width: 100%;
}

.frp-legend-wrap {
  position: relative;
}

.frp-legend-bar {
  transition: box-shadow 0.18s ease;
}

.frp-legend-bar.is-stuck {
  position: fixed;
  /* left is bound inline to the sidebar width (open 250px / collapsed 68px);
     combined with right:0 + margin auto + max-width it centers over the main
     content, exactly like .frp-filter-banner. */
  top: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  max-width: 1344px;
  /* Below the filter banner (200) but above the board content. */
  z-index: 30;
  box-shadow: 0 2px 8px rgba(10, 10, 10, 0.14),
    0 0 0 1px rgba(10, 10, 10, 0.08) !important;
}

/* When a filter is active, the fixed filter banner (42px tall) owns the very
   top, so dock the legend just beneath it. */
.frp-legend-bar.is-stuck.is-filtered {
  top: 42px;
}

@media (max-width: 768px) {
  .frp-legend-bar.is-stuck {
    left: 68px !important;
  }
}

.frp-graph-area {
  position: relative;
  width: 100%;
  height: 110px;
}

.frp-graph-area .chart-container {
  height: 100% !important;
}

.frp-card-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.frp-card-header .icon {
  color: #4a4a4a;
}

/* Igualar el tamaño del título con el de la tarjeta Encuestados (KpiCard usa
   0.9rem), para que las tres cabeceras del row queden parejas. */
.frp-card-header .title {
  font-size: 0.9rem;
}

.frp-card-divider {
  margin: 0.5rem 0 1rem;
  background-color: whitesmoke;
  height: 2px;
  /* En las tarjetas flex-column el hr es un flex-item: sin esto se encoge a
     0 y desaparece. Lo forzamos a alto fijo y ancho completo. */
  flex-shrink: 0;
  width: 100%;
}

/* Cuerpo de la tarjeta Forma. Con subtotales se divide en 2 columnas:
   el pie a la izquierda y los subtotales (dos filas apiladas) a la derecha,
   para no crecer en vertical. */
.frp-forma-body.has-intra {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex: 1 1 auto;
}

.frp-forma-body.has-intra .frp-graph-area {
  flex: 0 0 36%;
  width: 36%;
  /* Pie más pequeño (igual que Casos críticos) para que las tres tarjetas
     tengan la misma altura de contenido. */
  height: 100px;
}

/* Subtotales por forma como tabla sin bordes: una columna por forma (A/B) y las
   métricas (nombre + %, promedio, nivel) como filas. El color de riesgo va sólo
   en el valor; un swatch con el color del pie precede a cada "Forma X". */
.frp-forma-table {
  flex: 1 1 auto;
  min-width: 0;
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
  color: #363636;
}

.frp-forma-table th,
.frp-forma-table td {
  border: none;
  text-align: left;
  padding: 0.2rem 0.3rem;
  vertical-align: middle;
  white-space: nowrap;
}

.frp-forma-table thead th {
  font-weight: 700;
  padding-bottom: 0.35rem;
}

.frp-forma-table tbody tr:first-child td {
  padding-top: 0.1rem;
}

/* La última fila (nivel de riesgo) puede traer textos largos
   ("Sin riesgo o riesgo despreciable"): se deja envolver dentro de su columna
   para que no se solape con la forma vecina. */
.frp-forma-table tbody tr:last-child td {
  white-space: normal;
  vertical-align: top;
}


/* Pastilla de periodicidad global en la cabecera de la tarjeta Forma. */
.frp-forma-period {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.1rem 0.5rem;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.7rem;
  font-weight: 600;
  white-space: nowrap;
}

.frp-forma-period .icon {
  font-size: 14px;
}

.frp-forma-period--alta {
  background: #facca5;
  border-color: #f6b884;
  color: #8a4b1e;
}

.frp-forma-period--baja {
  background: #d9ead3;
  border-color: #c3eab5;
  color: #3d6b2f;
}

.frp-forma-info {
  margin-left: 0.4rem;
  color: #b5b5b5;
  cursor: help;
  display: inline-flex;
}

.frp-forma-info .material-icons {
  font-size: 18px;
}

.frp-fi-swatch {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 0.35rem;
  vertical-align: middle;
}

.frp-fi-forma {
  font-weight: 700;
  font-size: 0.8rem;
  white-space: nowrap;
}

.frp-fi-prom {
  display: inline-block;
  font-weight: 700;
  font-size: 0.95rem;
  line-height: 1.1;
  padding: 0.05rem 0.45rem;
  border: 1px solid transparent;
  border-radius: 6px;
}

.frp-fi-nivel {
  display: block;
  font-size: 0.74rem;
  font-weight: 400;
  white-space: normal;
  line-height: 1.15;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/Resultados.vue